import React, { useState, useEffect, useRef } from "react";
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import { IMaskInput } from "react-imask";
import { situacaoPagamento, 
         situacaoPagamentoNovo,
         pesquisa_cep, 
         pagamento, 
         pagamentoCartao, 
         pagamentoCartaoNovo, 
         getProduto, 
         getVenda, 
         enviarSMS, 
         enviarWhats, 
         getUnidadePeloCodigo, 
         getEmpregado, 
         getAgencia, 
         getNumeroProposta, 
         finalizaVenda, 
         getContaById, 
         getProposta, 
         atualizaVenda } from "../componentes/api/DataApi";
import Modal from "react-bootstrap/Modal";

import DatePicker, { registerLocale, setDefaultLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import ptBR from 'date-fns/locale/pt-BR';

import { QrCodePix } from 'qrcode-pix';
import QRCode from 'react-qr-code';

import 'react-tabs/style/react-tabs.css';
import "bootstrap/dist/css/bootstrap.min.css";

import rapidex from '../images/rapidex.png';
import caixaAssistencia from '../images/caixa_assistencia.png';
import pasta from '../images/pasta.png';
import personagem from '../images/personagem.png';
import prancheta from '../images/prancheta.png';

import condicoesGerais from '../doc/condicoes_gerais.pdf';
import condicoesGeraisDobro from '../doc/condicoes_gerais_dobro.pdf';
import condicoesGeraisMulher from '../doc/condicoes_gerais_mulher.pdf';
import condicoesGeraisMEI from '../doc/condicoes_gerais_mei.pdf';
import condicoesGeraisBem from '../doc/condicoes_gerais_bem.pdf';
import condicoesGeraisTag from '../doc/condicoes_gerais_tag.pdf';

import Skeleton from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'
import { useNavigate } from "react-router-dom";

import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Carousel } from 'react-responsive-carousel';

import { useDropzone } from 'react-dropzone';

import LoadingMask from "../componentes/LoadingMask";
import ModalHeader from "react-bootstrap/esm/ModalHeader";
import { format } from "date-fns";

import { BiCheck } from "react-icons/bi";
import { FiPaperclip } from "react-icons/fi";
import { IoLockClosed } from "react-icons/io5";
import { IoMdEye } from "react-icons/io";
import { IoMdEyeOff } from "react-icons/io";
import { FaEnvelope } from "react-icons/fa";
import { AiOutlineClose, AiOutlineFileText } from "react-icons/ai";
import { BsCheckCircleFill, BsXCircle, BsStopwatch } from "react-icons/bs";
import { MdDateRange } from "react-icons/md";

import Countdown, { CountdownApi } from "react-countdown";
import { sanitizeText } from "../componentes/apoio/suporte";

const isValidEmail = email =>
    /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
        email
    );

const escapeRegExp = (string) => {
    return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

const replaceAll = (str, find, replace) => {
    return str.replace(new RegExp(escapeRegExp(find), 'g'), replace);
}

const validaDigitoConta = (agencia, produto, conta, digito) => {
    if (typeof produto === "undefined")
        return false;

    if (produto.trim() === "")
        return false;

    if (typeof conta === "undefined")
        return false;

    if (conta.trim() === "")
        return false;

    if (typeof digito === "undefined")
        return false;

    if (digito.trim() === "")
        return false;

    let multiplicador = "2345678923456789";

    let bufforiginal = replaceAll(replaceAll(conta, ".", ""), "-", "");

    let soma = 0;
    let resto = 0;

    if (produto === "037" || produto === "013" || produto === "022" || produto === "001" || produto === "003") {
        if (conta.length !== 8)
            return false;

        bufforiginal = `${agencia}${produto}${bufforiginal}`;
    }
    else {
        if (conta.length !== 12)
            return false;
    }

    let buffconta = bufforiginal.split("").reverse().join("");
    let buffdigito = digito;

    for (var i = 0; i < buffconta.length; i++) {
        let contaCaracter = parseInt(buffconta.substr(i, 1));
        let operador = parseInt(multiplicador.substr(i, 1));

        let valor = contaCaracter * operador;

        soma += valor;
    }

    resto = (soma * 10) % 11;

    if (resto >= 10)
        resto = 0;

    return parseInt(buffdigito) === resto;
}

const validaCelular = celular => {
    if (typeof celular === "undefined")
        return false;

    if (celular.trim() === "")
        return false;

    let bufforiginal = replaceAll(replaceAll(replaceAll(replaceAll(celular, "(", ""), ")", ""), " ", ""), "-", "");

    if (bufforiginal.length < 11)
        return false;

    if (bufforiginal.substr(2, 1) !== "9")
        return false;

    return true;
}

export default function VendaPage() {
    var timeout;
    var timeout_focus;

    const intervalPagamento = useRef(null);

    registerLocale('ptBR', ptBR);

    const navigate = useNavigate();

    const countdownRef = useRef(null);    

    const [loading, setLoading] = useState(false);
    const [contratar, setContratar] = useState(false);
    const [sms, setSms] = useState(false);
    const [tabIndex, setTabIndex] = useState(0);
    const [codigoSMS, setCodigoSMS] = useState();

    const [originEnvioSMS, setOriginEnvioSMS] = useState("S");

    const [erro, setErro] = useState(false);
    const [mensagemErro, setMensagemErro] = useState();

    const [reenviarSMS, setReenviarSMS] = useState(false);
    const [proibidoReenviarSMS, setProibidoReenviarSMS] = useState(false);
    const [proibidoEnviarWhats, setProibidoEnviarWhats] = useState(true);
    const [valorSMS, setValorSMS] = useState();
    const [finalizando, setFinalizando] = useState(false);
    const [tutorial, setTutorial] = useState(false);
    const [modalErro, setModalErro] = useState(false);
    const [arquivoAnexado, setArquivoAnexado] = useState(false);
    const [propostaFinalizada, setPropostaFinalizada] = useState(false);
    const [readOnlyDataPagamento, setReadOnlyDataPagamento] = useState(true);
    const [modalPagamentoCartao, setModalPagamentoCartao] = useState(false);
    const [modalPagamentoCartaoNovo, setModalPagamentoCartaoNovo] = useState(false);    
    const [modalPagamentoPix, setModalPagamentoPix] = useState(false);
    const [modalPagamentoPixNovo, setModalPagamentoPixNovo] = useState(false);    
    const [showCardNumber, setShowCardNumber] = useState(false);
    const [showCVV, setShowCVV] = useState(false);
    const [showCardExpiration, setShowCardExpiration] = useState(false);
    const [pagamentoEfetuado, setPagamentoEfetuado] = useState(0);

    const [showCountSms, setShowCountSms] = useState(false);
    const [showCountReenviarSms, setShowCountReenviarSms] = useState(false);
    const [showCountWhats, setShowCountWhats] = useState(false);
    
    const [popupTag, setPopupTag] = useState(false)

    const { acceptedFiles, getRootProps, getInputProps, open } = useDropzone({
        maxFiles: 1,
        noClick: true,
        noKeyboard: true,
        noDrag: true,
        maxSize: 5000000,
        accept: {
            'application/pdf': ['.pdf']
        },
        onFileDialogOpen: files => {
            setArquivoAnexado(false);
        },
        onDropAccepted: files => {
            setArquivoAnexado(true);

            let reader = new FileReader();
            reader.readAsDataURL(files[0]);

            reader.onload = function () {
                setVenda({
                    ...venda,
                    arquivo_proposta: {
                        nome: files[0].name,
                        tipo: files[0].type,
                        arquivo: replaceAll(reader.result, "data:application/pdf;base64,", ""),
                        tamanho: files[0].size,
                        documento: 1
                    }
                });
            };
        },
        onDropRejected: files => {
            let code = files[0].errors[0].code;

            setModalErro(true);
            setArquivoAnexado(false);

            if (code === "file-invalid-type") {
                setMensagemErro("Não é possível anexar aquivo que não seja do tipo PDF");
            }
            else if (code === "file-too-large") {
                setMensagemErro("Tamanho do arquivo maior do que o permitido, máximo permitido 500k");
            }
            else {
                setMensagemErro("Erro desconhecido, entre em contato com o suporte");
            }
        }
    });

    const limparAnexo = () => {
        setArquivoAnexado(false);
        acceptedFiles.pop();
    }

    const files = acceptedFiles.map(file => (
        <div key={file.path}>
            {!propostaFinalizada ?
                <>
                <AiOutlineClose size={20} color="red" style={{cursor: "pointer"}} onClick={() => limparAnexo()}></AiOutlineClose> <AiOutlineFileText size={20}></AiOutlineFileText>{file.path}
                </>
            :
                <>
                <AiOutlineFileText size={20}></AiOutlineFileText>{file.path}
                </>
            }
        </div>
    ));

    const [loadingMask, setLoadingMask] = useState({
        upload: false,
        sms: false,
        newSms: false,
        atualizaVenda: false,
        pagamento: false,
        pagamentoPix: false
    });

    const [validacao, setValidacao] = useState({
        emailErro: "",
        emailConfirmacaoErro: "",
        celularErro: "",
        modalidadeErro: "",
        planoErro: "",
        pagamentoErro: "",
        contaErro: "",
        contaDigitadaErro: "",
        debitoAutomaticoErro: "",
        agenciaDigitadaErro: "",
        empregadoErro: "",
        logradouroCepErro: "",
        logradouroEnderecoErro: "",
        logradouroNumeroErro:  "",
        logradouroBairroErro: "",
        logradouroCidadeErro: "",
        logradouroEstadoErro: ""
    });


    const [cartao, setCartao] = useState({
        flag: "",
        cardNumber: "",
        cardHolder: "",
        cardExpiration: "",
        cardCVV: ""
    });

    const [venda, setVenda] = useState({
        id: "",
        proposta: "",
        nome: "",
        cpf: "",
        cpfMask: "",
        email: "",
        emailConfirmacao: "",
        celular: "",
        modalidade: "",
        renovacaoAutomatica: "N",
        debitoDemaisParcelas: "N",
        pagamento: "",
        data_pagamento: new Date(),
        usuarioLogado: false,
        agencia: "",
        id_pre_venda: 0,
        contas: [],
        tipo_produto: "",
        venda_sms: false,
        habilitaVendaSMS: true,
        maiorIgual70: false,
        mei: false,
        ofertar: "",
        tipoPessoa: "1",
        sexo: "",
        url: "",
        pix: "",
        dobro: "",
        nsu: "",
        formaVenda: "",
        vendedor: {
            agencia: "",
            nomeAgencia: "",
            matricula: "",
            cpf: "",
            nome: "",
        },
        produto: {
            id: "",
            codigo: "",
            descricao: "",
            proposta: "",
            proposta_recorrente: "",
            valor: "",
            nome: "",
            dobro: false
        },
        boleto: {
            codigo_barras: "",
            linha_digitavel: "",
            url: ""
        },
        conta_pagamento: {
            id: "",
            agencia: "",
            produto: "",
            conta: "",
            digito: ""
        },
        arquivo_proposta: {
            nome: "",
            tipo: "",
            arquivo: null,
            tamanho: 0,
            documento: 1
        },
        logradouro: {
            endereco: "",
            numero: "",
            complemento: "",
            bairro: "",
            cidade: "",
            uf: "",
            cep: ""
        }
    });

    useEffect(() => {
        setLoading(true);

        getVenda(callBackVenda);
    }, []);

    useEffect(() => {
        if (venda.nsu && venda.url === "pagamento_pix") {
            console.log("venda", venda);

            setModalPagamentoPixNovo(true);
        }
    }, [venda.nsu]);     

    const onAtualizaProduto = (e) => { 
        if (e.target.value === "RAPIDEX_MOB") {
            setPopupTag(true)

            getProduto("SEMESTRAL_MOB", (response) => {
                if (response) {
                    setReadOnlyDataPagamento(e.target.value !== "MEI_MENSAL" &&
                                             e.target.value !== "MENSAL");
    
                    setVenda({
                        ...venda,
                        tipo_produto: "RAPIDEX_MOB",
                        modalidade: "SEMESTRAL_MOB",
                        debitoDemaisParcelas: "N",
                        renovacaoAutomatica: "N",
                        data_pagamento: new Date(),
                        pagamento: "",
                        boleto: {
                            codigo_barras: "",
                            linha_digitavel: "",
                            url: ""
                        },
                        conta_pagamento: {
                            id: "",
                            agencia: "",
                            produto: "",
                            conta: "",
                            digito: ""
                        },
                        arquivo_proposta: {
                            nome: "",
                            tipo: "",
                            arquivo: null,
                            tamanho: 0,
                            documento: 1
                        },
                        produto: {
                            id: response.id,
                            codigo: response.codigoProduto,
                            descricao: response.descricao,
                            proposta: response.proposta,
                            proposta_recorrente: response.propostaRecorrente ?? "",
                            valor: response.valor,
                            nome: response.titulo,
                            dobro: response.dobro
                        }
                    });
                }
            });
        }
        else {
            setVenda({
                ...venda,
                tipo_produto: e.target.value,
                modalidade: "",
                debitoDemaisParcelas: "N",
                renovacaoAutomatica: "N",
                pagamento: "",
                produto: {
                    id: "",
                    codigo: "",
                    descricao: "",
                    proposta: "",
                    proposta_recorrente: "",
                    valor: "",
                    nome: "",
                    dobro: false
                },
                boleto: {
                    codigo_barras: "",
                    linha_digitavel: "",
                    url: ""
                },
                conta_pagamento: {
                    id: "",
                    agencia: "",
                    produto: "",
                    conta: "",
                    digito: ""
                },
                arquivo_proposta: {
                    nome: "",
                    tipo: "",
                    arquivo: null,
                    tamanho: 0,
                    documento: 1
                }
            });
        }
    }

    const onAtualizaModalidade = (e) => {
        getProduto(e.target.value, (response) => {
            if (response) {
                setReadOnlyDataPagamento(e.target.value !== "MEI_MENSAL" &&
                                         e.target.value !== "MENSAL");

                                          
                if (!response.dobro) {
                    setVenda({
                        ...venda,
                        modalidade: e.target.value,
                        debitoDemaisParcelas: "N",
                        renovacaoAutomatica: "N",
                        data_pagamento: new Date(),
                        pagamento: "",
                        produto: {
                            id: response.id,
                            codigo: response.codigoProduto,
                            descricao: response.descricao,
                            proposta: response.proposta,
                            proposta_recorrente: response.propostaRecorrente ?? "",
                            valor: response.valor,
                            nome: response.titulo,
                            dobro: response.dobro ? "S" : "N"
                        }
                    });
                }
                else {
                    setVenda({
                        ...venda,
                        modalidade: e.target.value,
                        debitoDemaisParcelas: "N",
                        renovacaoAutomatica: "N",
                        data_pagamento: new Date(),
                        pagamento: "",
                        produto: {
                            id: response.id,
                            codigo: response.codigoProduto,
                            descricao: response.descricao_dobro,
                            proposta: response.proposta_dobro,
                            proposta_recorrente: response.proposta_dobro_recorrente ?? "",
                            valor: response.valor,
                            nome: response.titulo,
                            dobro: response.dobro ? "S" : "N"
                        }
                    });
                }
            }
        });
    }

    useEffect(() => {
        setLoading(true);

        getVenda(callBackVenda);
    }, []);
    
    useEffect(() => {
        //console.log(venda);
    }, [venda])

    let tentativa = 0;

    const callBackVenda = (response) => {
        if (response && response.codigo !== -9) {
            if (response.codigo === -3) {
                navigate("/erro/?erro=109");
            }
            else if (response.codigo === -4) {
                navigate("/erro/?erro=110");
            }
            else if (response.codigo === -5) {
                navigate("/erro/?erro=108");
            }
            else if (response.codigo === -10) {
                navigate("/erro/?erro=150");
            }
            else if (response.codigo === 0) {
                let contas = [];

                if (response.contas) {
                    response.contas.forEach(item => {
                        contas.push({
                            id: item.id,
                            conta: `${item.agencia}.${item.produto}.${item.numero}-${item.digito}`
                        });
                    });
                }

                let celular = "";

                if (response.celular) {
                    if (response.celular.length >= 11)
                        celular = response.celular;
                }

                setVenda({
                    ...venda,
                    id: response.id,
                    formaVenda: response.formaVenda || "",
                    agencia: response.agencia,
                    nome: response.nome,
                    cpf: response.cpf,
                    cpfMask: response.cpfMask,
                    celular: celular,
                    email: response.email,
                    contas: contas,
                    vendedor: {
                        ...venda.vendedor,
                        agencia: response.nomeAgencia ? response.agencia : "",
                        nomeAgencia: response.nomeAgencia || "",
                        matricula: (response.formaVenda || "").toUpperCase() === "CCA" ? "" : (response.matriculaVendedor || ""),
                        nome: (response.formaVenda || "").toUpperCase() === "CCA" ? "" : (response.nomeVendedor || "")
                    },
                    usuarioLogado: true,
                    habilitaVendaSMS: response.habilitaVendaSMS,
                    maiorIgual70: response.maiorIgual70,
                    mei: response.mei,
                    ofertar: response.ofertar,
                    tipoPessoa: response.tipoPessoa,
                    sexo: response.sexo,
                    id_pre_venda: parseInt(localStorage.getItem("IdPreVenda")),
                    dobro: response.dobro,
                    logradouro: {
                        endereco: response.endereco,
                        numero: response.numero,
                        complemento: response.complemento,
                        bairro: response.bairro,
                        cidade: response.cidade,
                        uf: response.estado,
                        cep: response.cep
                    }
                });

                setLoading(false);

                getUnidadePeloCodigo(response.agencia, callBackUnidadePeloCodigo);
            }
            else {
                navigate("/erro/?erro=999");
            }
        }
        else {
            tentativa++;

            if (tentativa >= 8) {
                navigate("/erro/?erro=500&idprevenda=" + localStorage.getItem("IdPreVenda"));
            }
            else {
                setTimeout(() => {
                    getVenda(callBackVenda);
                }, 2100);
            }
        }
    }

    const onVoltarSMS = () => {
        setContratar(false);
        setVenda({
            ...venda,
            habilitaVendaSMS: true
        });
    }

    const atualizaInfoCartao = (e) => {
        let value = e.target.value;

        if (e.target.id === "cardExpiration") {
            value = e.target.value.replace(/\D/g, ""); // Remove tudo que não for dígito
            if (value.length > 2) {
              value = value.replace(/(\d{2})(\d{2})/, "$1/$2"); // Adiciona barra entre mês/ano
            }
        }
        else if (e.target.id === "cardCVV") {
            value = e.target.value.replace(/\D/g, "").slice(0, 4); // Aceita apenas números e limita a 4 dígitos
        }
        else if (e.target.id === "flag") {
            value = e.target.value;
        }

        setCartao({
            ...cartao,
            [e.target.id]: value
        });
    }

    const identificarBandeira = (numero) => {
        let value = numero.replace(/\D/g, ""); // Remove tudo que não for dígito
        value = value.replace(/(\d{4})(\d)/g, "$1 $2"); // Adiciona espaços a cada 4 dígitos

        setCartao({
            ...cartao,
            cardNumber: value
        });
    };

    const toggleDetailsClick = () => {
        const btnToggleDetails = document.getElementById("btnToggleDetails");

        const details = document.getElementById("idDetails");

        if (details.style.display === "none" || details.style.display === "") {
            details.style.display = "block";
            btnToggleDetails.textContent = "-";
        } else {
            details.style.display = "none";
            btnToggleDetails.textContent = "+";
        }
    };


    const toggleCardNumberClick = () => {
        setShowCardNumber(!showCardNumber);

        const cardNumber = document.getElementById("cardNumber");

        if (cardNumber.type === "password") {
          cardNumber.type = "text";
        } else {
          cardNumber.type = "password";
        }
    };

    const toggleCVVClick = () => {
        setShowCVV(!showCVV);

        const cardCvv = document.getElementById("cardCVV")

        if (cardCvv.type === "password") {
            cardCvv.type = "text";
          } else {
            cardCvv.type = "password";
          }
    }

    const toggleCardExpirationClick = () => {
        setShowCardExpiration(!showCardExpiration);

        const cardExpiration = document.getElementById("cardExpiration")

        if (cardExpiration.type === "password") {
            cardExpiration.type = "text";
          } else {
            cardExpiration.type = "password";
          }
    }

    const callBackUnidadePeloCodigo = (response) => {
        if (response && response.codigo === 0) {
            if (response.habilitada === 0) {
                navigate("/erro/?erro=105");
            }

        }
    }

    const onAtualizaDataPagamento = (e) => {
        if (e === null || (e.getDate() >= 29 && e.getDate() <= 31)) {
            e = new Date();
        }

        setVenda({...venda, "data_pagamento": e});
    }

    const onAtualiza = (e) => {
        let valor = e.target.value;
        let buffVenda = { ...venda };

        if (e.target.name === "agenciaVendedor") {
            buffVenda.vendedor = { ...buffVenda.vendedor, agencia: valor, nomeAgencia: "" };

            setVenda(buffVenda);
        }
        else if (e.target.name === "matriculaVendedor") {
            buffVenda.vendedor = { ...buffVenda.vendedor, matricula: valor, nome: "", cpf: "" };

            setVenda(buffVenda);
        }
        else if (e.target.name === "logradouroCep") {
            buffVenda.logradouro.cep = replaceAll(valor, "-", "");

            setVenda(buffVenda);
        }
        else if (e.target.name === "logradouroEndereco") {
            buffVenda.logradouro.endereco = valor;

            setVenda(buffVenda);
        }
        else if (e.target.name === "logradouroNumero") {
            buffVenda.logradouro.numero = valor;

            setVenda(buffVenda);
        }
        else if (e.target.name === "logradouroComplemento") {
            buffVenda.logradouro.complemento = valor;

            setVenda(buffVenda);
        }
        else if (e.target.name === "logradouroBairro") {
            buffVenda.logradouro.bairro = valor;

            setVenda(buffVenda);
        }
        else if (e.target.name === "logradouroCidade") {
            buffVenda.logradouro.cidade = valor;

            setVenda(buffVenda);
        }
        else if (e.target.name === "logradouroEstado") {
            buffVenda.logradouro.uf = valor;

            setVenda(buffVenda);
        }
        else {
            setVenda({ ...venda, [e.target.name]: e.target.value });
        }
    }

    const onAtualizaCep = (e) => {
        let valor = e.target.value;

        onAtualiza(e);

        pesquisa_cep(valor, (response) => {
            if (response) {
                var info_cep = JSON.parse(JSON.stringify(response));

                if (!info_cep.erro) {
                    var cep = replaceAll(info_cep.cep, "-", "");
                  
                    setVenda({...venda,
                        logradouro: { 
                            endereco: info_cep.logradouro?.slice(0,200),
                            numero: "",
                            complemento: info_cep.complemento?.slice(0,35),
                            bairro: info_cep.bairro?.slice(0,50),
                            cidade: info_cep.localidade?.slice(0,50),
                            uf: info_cep.uf,
                            cep: cep
                        }
                    });
                }
            }
            else if (valor.length < 9) {
                setVenda({...venda,
                    logradouro: { 
                        endereco: "",
                        numero: "",
                        complemento: "",
                        bairro: "",
                        cidade: "",
                        uf: "",
                        cep: ""
                    }
                });
            }
        })
    }

    const onAtualizaPagamento = (e) => {
        setVenda({ ...venda, [e.target.name]: e.target.value, 
                             conta_pagamento: { id: "", agencia: "", produto: "", conta: "", digito: "" },
                             debitoDemaisParcelas: "N"});

        setValidacao({ contaErro: "" });
    }

    const callbackConta = (response) => {
        if (response) {
            setVenda({
                ...venda,
                conta_pagamento: {
                    id: response.id,
                    agencia: response.agencia,
                    produto: response.produto,
                    conta: response.numero,
                    digito: response.digito
                }
            });
        }
    }

    const onSelecionaConta = (e) => {
        getContaById(e.target.value, callbackConta);
    }

    const onSairJanelaSMS = () => {
        setSms(false);
        setProibidoReenviarSMS(false);
        setProibidoEnviarWhats(true);
        setLoadingMask({ sms: false });
    }

    const onContratar = () => {
        var existeErro = false;

        let agenciaDigitadaErro = "";
        let empregadoErro = "";

        // agência e matrícula são validadas no onBlur (nomeAgencia e nome só são preenchidos quando válidos)
        if (venda.vendedor.agencia.trim() === "") {
            agenciaDigitadaErro = "Agência deve ser informada";

            existeErro = true;
        }
        else if (venda.vendedor.nomeAgencia === "") {
            agenciaDigitadaErro = "Agência inválida";

            existeErro = true;
        }

        // forma de venda CCA: apenas a agência é solicitada
        if (venda.formaVenda.toUpperCase() !== "CCA") {
            if (venda.vendedor.matricula.trim() === "") {
                empregadoErro = "Matrícula deve ser informada";

                existeErro = true;
            }
            else if (venda.vendedor.nome === "") {
                empregadoErro = "Matrícula inválida";

                existeErro = true;
            }
        }

        var emailErro = "";
        var emailConfirmacaoErro = "";

        if (venda.email && venda.email.trim() !== "") {
            if (!isValidEmail(venda.email)) {
                emailErro = "E-mail inválido";

                existeErro = true;
            }

            if (venda.email !== venda.emailConfirmacao) {
                emailConfirmacaoErro = "Os campos não coincidem";

                existeErro = true;
            }
        }

        var celularErro = "";
        if (venda.celular.trim() === "") {
            celularErro = "Necessário informar o celular";

            existeErro = true;
        }
        else if (!validaCelular(venda.celular)) {
            celularErro = "Celular inválido";

            existeErro = true;
        }

        var modalidadeErro = "";
        var debitoAutomaticoErro = "";
        var planoErro = "";

        if (venda.tipo_produto.trim() === "") {
            modalidadeErro = "Necessário selecionar um produto";

            existeErro = true;
        }

        if (venda.modalidade.trim() === "") {
            planoErro = "Necessário selecionar um plano";

            existeErro = true;
        }

        if ((venda.modalidade.trim() === "MENSAL" || venda.modalidade.trim() === "MEI_MENSAL") && venda.debitoDemaisParcelas === "N") {
            debitoAutomaticoErro = "Necessário selecionar a autorização de débito das demais parcelas";

            existeErro = true;
        }

        var pagamentoErro = "";
        var contaErro = "";
        var contaDigitadaErro = "";
        if (venda.pagamento.trim() === "") {
            pagamentoErro = "Necessário selecionar uma forma de pagamento";

            existeErro = true;
        }
        else if (venda.pagamento != "CR" && (venda.pagamento === "DB" || venda.debitoDemaisParcelas === "S" || venda.renovacaoAutomatica === "S")) {
            if (venda.conta_pagamento.id.trim() === "" && venda.conta_pagamento.agencia.trim() === "") {
                contaErro = "Necessário informar ou selecionar uma conta de pagamento";

                existeErro = true;
            }

            if (venda.conta_pagamento.id.trim() === "" && (venda.conta_pagamento.agencia.trim() === "" ||
                venda.conta_pagamento.produto.trim() === "" ||
                venda.conta_pagamento.conta.trim() === "" ||
                venda.conta_pagamento.digito.trim() === "")) {
                contaErro = "Necessário informar todas informações da conta";

                existeErro = true;
            }

            if (venda.conta_pagamento.id === "" && !validaDigitoConta(venda.conta_pagamento.agencia, venda.conta_pagamento.produto, venda.conta_pagamento.conta, venda.conta_pagamento.digito)) {
                contaDigitadaErro = "Conta inválida";

                existeErro = true;
            }
        }

        var cepErro = "";
        var enderecoErro = "";
        var numeroErro = "";
        var bairroErro = "";
        var cidadeErro = "";
        var estadoErro = "";

        if (venda.logradouro.cep.trim() === "" || replaceAll(venda.logradouro.cep, "-", "").length != 8) {
            cepErro = "Necessário informar o CEP";

            existeErro = true;
        }

        if (venda.logradouro.endereco.trim() === "") {
            enderecoErro = "Necessário informar o endereço";

            existeErro = true;
        }

        if (venda.logradouro.numero.trim() === "") {
            numeroErro = "Necessário informar o número";

            existeErro = true;
        }

        if (venda.logradouro.bairro.trim() === "") {
            bairroErro = "Necessário informar o bairro";

            existeErro = true;
        }

        if (venda.logradouro.cidade.trim() === "") {
            cidadeErro = "Necessário informar o cidade";

            existeErro = true;
        }

        if (venda.logradouro.uf.trim() === "") {
            estadoErro = "Necessário informar o estado";

            existeErro = true;
        }

        setValidacao({
            agenciaDigitadaErro: agenciaDigitadaErro,
            empregadoErro: empregadoErro,
            emailErro: emailErro,
            emailConfirmacaoErro: emailConfirmacaoErro,
            celularErro: celularErro,
            modalidadeErro: modalidadeErro,
            planoErro: planoErro,
            debitoAutomaticoErro: debitoAutomaticoErro,
            pagamentoErro: pagamentoErro,
            contaErro: contaErro,
            contaDigitadaErro: contaDigitadaErro,
            logradouroCepErro: cepErro,
            logradouroEnderecoErro: enderecoErro,
            logradouroNumeroErro: numeroErro,
            logradouroBairroErro: bairroErro,
            logradouroCidadeErro: cidadeErro,
            logradouroEstadoErro: estadoErro
        });

        if (existeErro) {
            return false;
        }

        setLoadingMask({ atualizaVenda: true });

        atualizaVenda(venda, (responseAtualizaVenda) => {
            if (responseAtualizaVenda) {
                if (responseAtualizaVenda.codigo === 0) {
                    setLoadingMask({ atualizaVenda: false });

                    setContratar(true);
                }
                else {
                    setLoadingMask({ atualizaVenda: false });

                    setModalErro(true);
                    setMensagemErro(responseAtualizaVenda.mensagem);
                }
            }
            else {
                setLoadingMask({ atualizaVenda: false });

                setModalErro(true);
                setMensagemErro("Erro ao tentar atualizar a venda");
            }
        });
    }

    const geraPdfProposta = (numProposta, callback) => {
        getProposta(venda.id, venda.produto.codigo, venda.renovacaoAutomatica, async (response) => {
            if (response) {
                if (response?.codigo <= -1) {
                    window.alert("Erro na criação do contrato");
                }
                else {
                    const base64Response = await fetch(`data:application/pdf;base64,${response.proposta}`);

                    const blobFromFetch= await base64Response.blob();
    
                    var blob = new Blob([blobFromFetch], {type: "application/pdf"});
                    
                    const blobUrl = URL.createObjectURL(blob);
                
                    window.open(blobUrl,"_blank");                
                    window.open(blobUrl,"_blank");    
                    
                    callback();
                }
            }
        });
    }

    const imprimirProposta = (showTutorial) => {
        setFinalizando(true);
        setLoadingMask({ sms: true });

        if (!venda.proposta) {
            getNumeroProposta(venda.id, venda.vendedor.agencia.trim() || venda.agencia, (responseProposta) => {
                if (responseProposta) {
                    setVenda({
                        ...venda,
                        proposta: responseProposta.numeroProposta
                    });

                    geraPdfProposta(responseProposta.numeroProposta, () => {
                        setLoadingMask({ sms: false });

                        setTabIndex(1);
                        setContratar(false);
                        setFinalizando(false);

                        setTutorial(showTutorial);
                    });
                }
                else {
                    setLoadingMask({ sms: false });

                    setFinalizando(false);
                }
            })
        }
        else {
            geraPdfProposta(venda.proposta, () => {
                setLoadingMask({ sms: false });

                setTabIndex(1);
                setContratar(false);
                setFinalizando(false);

                setTutorial(showTutorial);
            });
        }
    }

    const retornaMensagemContratar = () => {
        const valor = (venda.produto.valor) ? replaceAll(venda.produto.valor, ".", ",") : "";

        return (
            <div className="mensagem_contratar">
                {venda.tipo_produto === "MULHER" ?
                    <>
                        <p>Você vai contratar um RAPIDEX MULHER com as seguintes características:</p>
                        <br />
                        <p>Modalidade {venda.modalidade.substring(7)}</p>
                    </>
                :
                    <>
                        {venda.tipo_produto === "MEI" ?
                            <>
                                <p>Você vai contratar um RAPIDEX MEI com as seguintes características:</p>
                                <br />
                                <p>Modalidade {replaceAll(venda.modalidade.substring(4), "_", " ")}</p>
                            </>
                        :
                            <>
                                {venda.tipo_produto === "RAPIDEX_BEM" ?
                                    <>
                                    <p>Você vai contratar um RAPIDEX DO BEM com as seguintes características:</p>
                                    <br />
                                    <p>Modalidade {replaceAll(venda.modalidade, "_BEM", " ")}</p>
                                    </>
                                :
                                    <>
                                        {venda.tipo_produto === "RAPIDEX_MOB" ?
                                            <>
                                            <p>Você vai contratar um RAPIDEX +tagCAIXA com as seguintes características:</p>
                                            <br />
                                            <p>Modalidade {replaceAll(venda.modalidade, "_MOB", " ")}</p>
                                            </>
                                        :
                                            <>
                                            {venda.dobro === "S" && venda.produto.dobro ?
                                                <p>Você vai contratar um RAPIDEX + CUIDADO EM DOBRO com as seguintes características:</p>
                                            :
                                                <p>Você vai contratar um RAPIDEX + CUIDADO com as seguintes características:</p>
                                            }
                                            <br />
                                            <p>Modalidade {venda.modalidade} {venda.modalidade === "PLURIANUAL" && <span>(36 meses)</span>}</p>
                                            </>
                                        }
                                    </>
                                }
                            </>
                        }
                    </>
                }
                {venda.pagamento !== "CR" && (venda.pagamento === "DB" || venda.renovacaoAutomatica === "S" || venda.debitoDemaisParcelas === "S") &&
                    <p>Débitos ou reembolsos ocorrerão na conta: {venda.conta_pagamento.agencia}.{venda.conta_pagamento.produto}.{venda.conta_pagamento.conta}-{venda.conta_pagamento.digito}</p>
                }
                <p>Valor de R$ {valor}</p>
                <p>Forma de pagamento desta parcela: {(venda.pagamento === "BL" ? "BOLETO" : venda.pagamento === "PX" ? "PIX" : venda.pagamento === "CR" ? "CARTÃO DE CRÉDITO" : "Débito na conta informada acima")}</p>
                {venda.data_pagamento && venda.data_pagamento > new Date() &&
                    <>
                    <b><p>Débito da adesão agendado para o dia: {format(venda.data_pagamento, "dd/MM/yyyy")}</p></b>
                    <b><p>Demais parcelas serão debitadas na data escolhida pelo cliente</p></b>
                    </>
                }
                <br />
                <p>Caso queira prosseguir com esses dados, escolha como assinar a proposta. Caso precise corrigir alguma informação, clique em VOLTAR.</p>
                <br />
                {venda?.habilitaVendaSMS ?
                    <>
                    <p><strong>Para assinatura digital, escolha "Enviar SMS". Desta forma o cliente já recebe o token por SMS.</strong></p>
                    <p><strong>Em seguida é só informar no próximo pop-up, confirmar e pronto.</strong></p>
                    <br />
                    <p><strong>Caso não seja possível, imprima o contrato e pegue as assinaturas nos devidos campos.</strong></p>
                    </>
                    :
                    <>
                    <p><strong>“Em conformidade com a Lei Estadual 12.027/2021, as propostas para maiores de 60 anos, deverão ser impressas, assinadas e feito upload para finalizar a venda.”</strong></p>
                    <br />
                    <p><strong>Imprima o contrato e pegue as assinaturas nos devidos campos.</strong></p>
                    </>
                }
                <br />
                <p><strong>Muito obrigado!</strong></p>
            </div>
        )
    }

    const onConfirmar = () => {
        setFinalizando(true);

        if (valorSMS !== codigoSMS) {
            setFinalizando(false);
            setErro(true);
            setMensagemErro("Código SMS inválido");
        }
        else {
            setTabIndex(1);
            setContratar(false);
            setSms(false);

            finalizarProposta(venda?.proposta, true);
        }
    }

    const codicoesGerais = () => {
        setLoading(false);

        if (venda.tipo_produto === "MULHER")
            window.open(`${condicoesGeraisMulher}`, '_blank');
        else if (venda.tipo_produto === "MEI")
            window.open(`${condicoesGeraisMEI}`, '_blank');
        else if (venda.tipo_produto === "RAPIDEX_BEM")
            window.open(`${condicoesGeraisBem}`, '_blank');
        else if (venda.tipo_produto === "RAPIDEX_MOB")
            window.open(`${condicoesGeraisTag}`, '_blank');
        else if (venda.dobro === "S" && venda.produto.dobro)
            window.open(`${condicoesGeraisDobro}`, '_blank');
        else
            window.open(`${condicoesGerais}`, '_blank');
    }

    const onAtualizaRenovacaoAutomatica = (e) => {
        setVenda({
            ...venda, renovacaoAutomatica: (e.target.checked ? "S" : "N"),
            debitoDemaisParcelas: "N"
        });
    }

    const onAtualizaDebitoDemaisParcelas = (e) => {
        setVenda({
            ...venda, debitoDemaisParcelas: (e.target.checked ? "S" : "N"),
            renovacaoAutomatica: "N"
        });
    }

    const onReenviarSMS = () => {
        countdownRef.current && countdownRef.current.start();

        setOriginEnvioSMS("S");
        setReenviarSMS(true);
        setLoadingMask({ newSms: true });

        let celular = replaceAll(replaceAll(replaceAll(replaceAll(venda.celular, "(", ""), ")", ""), " ", ""), "-", "");

        enviarSMS(venda.id,
                  venda.conta_pagamento.id,
                  venda.produto.id,
                  venda.pagamento,
                  venda.renovacaoAutomatica,
                  celular,
                  "TOKEN_R",
                  venda.proposta, (response) => {
            if (response) {
                if (response.codigo === 0) {
                    setCodigoSMS(response.codigoSMS);
                    setReenviarSMS(false);
                    setProibidoReenviarSMS(true);
                    setLoadingMask({ newSms: false });
                    if (timeout) {
                        clearTimeout(timeout);
                    }
                    timeout = setTimeout(() => {
                        setProibidoReenviarSMS(false);
                        setProibidoEnviarWhats(false);
                    }, 50000);
                    if (timeout_focus) {
                        clearTimeout(timeout_focus);
                    }
                    timeout_focus = setTimeout(() => {
                        if (document.getElementById("num_sms"))
                            document.getElementById("num_sms").focus();
                    }, 900)
                }
                else {
                    setErro(true);
                    setMensagemErro("Houve um problema ao tentar enviar o código do SMS");
                    setReenviarSMS(false);
                    setLoadingMask({ newSms: false });
                }
            }
            else {
                setErro(true);
                setMensagemErro("Houve um problema ao tentar enviar o código do SMS");
                setReenviarSMS(false);
                setLoadingMask({ newSms: false });
            }
        });
    }

    const onReenviarWhats = () => {
        countdownRef.current && countdownRef.current.start();        

        setOriginEnvioSMS("W");
        setReenviarSMS(true);
        setLoadingMask({ newSms: true });

        let celular = replaceAll(replaceAll(replaceAll(replaceAll(venda.celular, "(", ""), ")", ""), " ", ""), "-", "");

        enviarWhats(venda.id,
                  venda.conta_pagamento.id,
                  venda.produto.id,
                  venda.pagamento,
                  venda.renovacaoAutomatica,
                  celular,
                  "TOKEN_RW",
                  venda.proposta, (response) => {
            if (response) {
                if (response.codigo === 0) {
                    setCodigoSMS(response.codigoSMS);
                    setReenviarSMS(false);
                    setProibidoReenviarSMS(true);
                    setLoadingMask({ newSms: false });
                    if (timeout) {
                        clearTimeout(timeout);
                    }
                    timeout = setTimeout(() => {
                        setProibidoReenviarSMS(false);
                        setProibidoEnviarWhats(false);
                    }, 50000);
                    if (timeout_focus) {
                        clearTimeout(timeout_focus);
                    }
                    timeout_focus = setTimeout(() => {
                        if (document.getElementById("num_sms"))
                            document.getElementById("num_sms").focus();
                    }, 900)
                }
                else {
                    setErro(true);
                    setMensagemErro("Houve um problema ao tentar enviar o código do SMS");
                    setReenviarSMS(false);
                    setLoadingMask({ newSms: false });
                }
            }
            else {
                setErro(true);
                setMensagemErro("Houve um problema ao tentar enviar o código do SMS");
                setReenviarSMS(false);
                setLoadingMask({ newSms: false });
            }
        });
    }

    const finalizarProposta = (numProposta, sms) => {
        setLoadingMask({ upload: true });

        if (venda.pagamento === "BL") {
            setVenda({
                ...venda,
                venda_sms: sms
            });

            var buffVenda = { ...venda };
            buffVenda.venda_sms = sms;

            finalizaVenda({ ...buffVenda }, (responseFinalizar) => {
                if (responseFinalizar.codigo === 0) {
                    setVenda({
                        ...venda,
                        boleto: {
                            codigo_barras: responseFinalizar.codigoBarras,
                            linha_digitavel: responseFinalizar.linhaDigitavel,
                            url: responseFinalizar.url
                        }
                    });

                    setFinalizando(false);

                    setPropostaFinalizada(true);

                    setLoadingMask({ upload: false });

                    if (venda.data_pagamento <= new Date()) {
                        window.open(responseFinalizar.url, '_blank');
                    }
                }
                else {
                    setModalErro(true);
                    setMensagemErro(responseFinalizar.mensagem);

                    setLoadingMask({ upload: false });
                }
            });
        }
        else {
            let buffVenda = { ...venda };

            buffVenda.proposta = numProposta;
            buffVenda.venda_sms = sms;

            finalizaVenda({ ...buffVenda }, (responseFinalizar) => {
                setFinalizando(false);

                console.log("responseFinalizar", responseFinalizar);

                if (responseFinalizar.codigo === 0) {
                    if ((venda.pagamento === "PX" || venda.pagamento === "CR") && venda.data_pagamento <= new Date()) {
                        if (venda.pagamento === "CR") {
                            if (venda.habilitaVendaSMS) {
                                setVenda({...venda, url: "pagamento_cartao", pix: ""});
                                // VINDI
                                //setModalPagamentoCartao(true);
                                setModalPagamentoCartaoNovo(true);
                            }
                        }
                        else {
                            setVenda({...venda, url: "pagamento_pix", pix: responseFinalizar.pix, nsu: responseFinalizar.nsu});

                            // VINDI
                            //setVenda({...venda, url: responseFinalizar.url, pix: responseFinalizar.pix});
                            //setModalPagamentoPix(true);
                        }
                    }
        
                    setPropostaFinalizada(true);
                    setLoadingMask({ upload: false });
                }
                else {
                    setModalErro(true);
                    setMensagemErro(responseFinalizar.mensagem);
                    setLoadingMask({ upload: false });
                }
            })
        }
    }

    const onEnviarCodigoSMS = () => {
        setOriginEnvioSMS("S");
        setLoadingMask({ sms: true });

        getNumeroProposta(venda.id, venda.vendedor.agencia.trim() || venda.agencia, (responseProposta) => {
            if (responseProposta) {
                setVenda({
                    ...venda,
                    proposta: responseProposta.numeroProposta
                });

                let celular = "55" + replaceAll(replaceAll(replaceAll(replaceAll(venda.celular, "(", ""), ")", ""), " ", ""), "-", "");

                enviarSMS( venda.id,
                           venda.conta_pagamento.id,
                           venda.produto.id,
                           venda.pagamento,
                           venda.renovacaoAutomatica,
                           celular,
                           "TOKEN",
                           venda.proposta,
                           (response) => {
                    if (response) {
                        if (response.codigo === 0) {
                            setCodigoSMS(response.codigoSMS);
                            setSms(true);
                            setProibidoReenviarSMS(true);
                            // Whats
                            setProibidoEnviarWhats(false);
                            setLoadingMask({ sms: false });
                            if (timeout) {
                                clearTimeout(timeout);
                            }
                            timeout = setTimeout(() => {
                                setProibidoReenviarSMS(false);
                            }, 50000);
                            if (timeout_focus) {
                                clearTimeout(timeout_focus);
                            }
                            timeout_focus = setTimeout(() => {
                                if (document.getElementById("num_sms"))
                                    document.getElementById("num_sms").focus();
                            }, 900)
                        }
                        else {
                            setErro(true);
                            setMensagemErro("Houve um problema ao tentar enviar o código do SMS");

                            setLoadingMask({ sms: false });
                        }
                    }
                    else {
                        setErro(true);
                        setMensagemErro("Houve um problema ao tentar enviar o código do SMS");

                        setLoadingMask({ sms: false });
                    }
                });
            }
            else {
                setLoadingMask({ sms: false });
            }
        });
    }

    const onSelecionaEmpregado = (e) => {
        setValidacao({ empregadoErro: "" });

        if (e.target.value !== "") {
            if (!/^c\d+$/i.test(e.target.value.trim())) {
                setValidacao({ empregadoErro: "Matrícula deve começar com c (ex.: c12345)" });

                return;
            }

            getEmpregado(e.target.value.trim(), (response) => {
                if (response && response.codigo === 0) {
                    if (venda.vendedor.agencia.trim() !== "" && response.codigoUnidade !== parseInt(venda.vendedor.agencia, 10)) {
                        setValidacao({ empregadoErro: "Matrícula não pertence à agência informada" });

                        return;
                    }

                    setVenda((atual) => ({
                        ...atual,
                        vendedor: { ...atual.vendedor, matricula: response.matricula, cpf: response.cpf, nome: response.nome }
                    }));
                }
                else {
                    setValidacao({ empregadoErro: "Matrícula inválida" });
                }
            })
        }
    }

    const onSelecionaAgencia = (e) => {
        setValidacao({ agenciaDigitadaErro: "" });

        if (e.target.value !== "") {
            getAgencia(e.target.value, (response) => {
                if (response && response.codigo === 0 && response.habilitada === 1) {
                    setVenda((atual) => ({
                        ...atual,
                        vendedor: { ...atual.vendedor, nomeAgencia: response.nomeAgencia }
                    }));
                }
                else {
                    setValidacao({ agenciaDigitadaErro: "Agência inválida" });
                }
            })
        }
    }

    const validaNomeCartao = (nome) => {
        if (nome === "")
            return false;

        return true;
    }

    const validaCVV = (cvv) => {
        if (cvv === "")
            return false;

        return true;
    }

    const validaDataExpiracao = (data_expiracao) => {
        if (data_expiracao === "") {
            return false;
        }

        let mes = data_expiracao.substring(0,2);

        if (parseInt(mes) < 1 || parseInt(mes) > 12)
            return false;

        let ano = data_expiracao.substring(3,5);

        let anoAtual = new Date().getFullYear().toString().slice(-2);

        if (parseInt(ano) < parseInt(anoAtual))
            return false;

        return true;
    }

    const onPagamentoCartaoNovo = () => {
        setLoadingMask({pagamento: true});

        if (validarBandeira(cartao.flag)) {
            if (validarCartao(cartao.cardNumber)) {
                if (validaNomeCartao(cartao.cardHolder)) {
                    if (validaDataExpiracao(cartao.cardExpiration)) {
                        if (validaCVV(cartao.cardCVV)) {
                            pagamentoCartaoNovo(venda, cartao, (response) => {
                                if (response) {
                                    console.log("Venda pagamento cartao", response);

                                    if (response.codigo === 0) {
                                        setVenda({
                                            ...venda,
                                            nsu: response.data.nsu
                                        });

                                        if (response.data.code === "0" && response.data.status === "CON") {
                                            setLoadingMask({pagamento: false});
                                            setPagamentoEfetuado(1);                                        
                                        }
                                        else if (response.data.code === "0" && response.data.status !== "CON") {
                                            setLoadingMask({pagamento: false});
                                            setPagamentoEfetuado(2);
                                            onShowConfirmarPagamentoNovo("CR");  
                                        }
                                        else if (response.data.code !== "0" && response.data.status === "NEG") {
                                            setErro(true);
                                            setMensagemErro("Transação negada. Tente novamente com outro cartão ou forma de pagamento.");
                                            setLoadingMask({pagamento: false});                                            
                                        }                                        
                                        else {
                                            setErro(true);
                                            setMensagemErro("Houve um erro no processamento do pagamento. Tente novamente.");
                                            setLoadingMask({pagamento: false});                                            
                                        }
                                    }
                                    else {
                                        if (response.codigo === -1) {
                                            setMensagemErro(response.mensagem);
                                        }
                                        else {
                                            setMensagemErro("Verifique se os dados estão corretos ou tente novamente com outro cartão");
                                        }

                                        setErro(true);
                                        setLoadingMask({pagamento: false});
                                    }
                                }
                                else {
                                    setErro(true);
                                    setMensagemErro("Verifique se os dados estão corretos ou tente novamente com outro cartão");
                                    setLoadingMask({pagamento: false});
                                }
                            });
                        }
                        else {
                            setErro(true);
                            setMensagemErro("CVV não informado");
                            setLoadingMask({pagamento: false});
                        }
                    }
                    else {
                        setErro(true);
                        setMensagemErro("Data de expiração inválida");
                        setLoadingMask({pagamento: false});
                    }
                }
                else {
                    setErro(true);
                    setMensagemErro("Nome não informado");
                    setLoadingMask({pagamento: false});
                }
            }
            else {
                setErro(true);
                setMensagemErro("Cartão inválido");
                setLoadingMask({pagamento: false});
            }
        }
        else {
            setErro(true);
            setMensagemErro("Bandeira não selecionada");
            setLoadingMask({pagamento: false});
        }
    }

    const onPagamentoCartao = () => {
        setLoadingMask({pagamento: true});

        if (validarBandeira(cartao.flag)) {
            if (validarCartao(cartao.cardNumber)) {
                if (validaNomeCartao(cartao.cardHolder)) {
                    if (validaDataExpiracao(cartao.cardExpiration)) {
                        if (validaCVV(cartao.cardCVV)) {
                            pagamentoCartao(cartao, (response) => {
                                if (response) {
                                    if (response.codigo === 0) {
                                        var gateway_token = response.data.payment_profile.gateway_token;

                                        pagamento(venda.id, gateway_token, (response) => {
                                            if (response.codigo === 0) {
                                                setLoadingMask({pagamento: false});
                                                setPagamentoEfetuado(2);
                                                onShowConfirmarPagamento("CR");
                                            }
                                            else {
                                                setErro(true);
                                                setMensagemErro("Houve um erro no processamento do pagamento. Tente novamente.");
                                                setLoadingMask({pagamento: false});
                                            }
                                        });
                                    }
                                    else {
                                        if (response.codigo === -1) {
                                            setMensagemErro(response.mensagem);
                                        }
                                        else {
                                            setMensagemErro("Verifique se os dados estão corretos ou tente novamente com outro cartão");
                                        }

                                        setErro(true);
                                        setLoadingMask({pagamento: false});
                                    }
                                }
                                else {
                                    setErro(true);
                                    setMensagemErro("Verifique se os dados estão corretos ou tente novamente com outro cartão");
                                    setLoadingMask({pagamento: false});
                                }
                            });
                        }
                        else {
                            setErro(true);
                            setMensagemErro("CVV não informado");
                            setLoadingMask({pagamento: false});
                        }
                    }
                    else {
                        setErro(true);
                        setMensagemErro("Data de expiração inválida");
                        setLoadingMask({pagamento: false});
                    }
                }
                else {
                    setErro(true);
                    setMensagemErro("Nome não informado");
                    setLoadingMask({pagamento: false});
                }
            }
            else {
                setErro(true);
                setMensagemErro("Cartão inválido");
                setLoadingMask({pagamento: false});
            }
        }
        else {
            setErro(true);
            setMensagemErro("Bandeira não selecionada");
            setLoadingMask({pagamento: false});
        }
    }

    const reexibirBoleto = () => {
        window.open(venda.boleto.url, '_blank');
    }

    const onFechaTutorial = () => {
        setTutorial(false);
    }

    const onAbrirPagamento = () => {
        if (venda.pagamento === "CR") {
            // VINDI
            //setModalPagamentoCartao(true);
            setModalPagamentoCartaoNovo(true);
            
            if (pagamentoEfetuado === 2) {
                validarPagamento("CR");
            }
        }
        else if (venda.pagamento === "PX") {
            // VINDI
            //setModalPagamentoPix(true);
            setModalPagamentoPixNovo(true);
        }
    }

    const disableDays = (date) => {
        let day = date.getDate();

        return day >= 1 && day <= 28;
    }

    const validarBandeira = (bandeira) => {
        if (bandeira === "")
            return false;

        return true;
    }

    const validarCartao = (numeroCartao) => {
        // Remover espaços em branco
        numeroCartao = numeroCartao.replace(/\s+/g, '');
        
        // Verificar se a entrada é numérica
        if (!/^\d+$/.test(numeroCartao)) {
            return false;
        }
    
        let soma = 0;
        let dobrar = false;
    
        // Iterar pelos dígitos do cartão da direita para a esquerda
        for (let i = numeroCartao.length - 1; i >= 0; i--) {
            let digito = parseInt(numeroCartao[i], 10);
    
            if (dobrar) {
                digito *= 2;
                if (digito > 9) {
                    digito -= 9;
                }
            }
    
            soma += digito;
            dobrar = !dobrar; // Alternar entre dobrar e não dobrar
        }
    
        // Retorna true se a soma for múltipla de 10
        return soma % 10 === 0;
    }    

    const Completionist = () => <span>&nbsp;</span>;

    const renderer_time = ({ hours, minutes, seconds, completed }) => {
        if (completed) {
          // Render a complete state
          return <Completionist />;
        } else {
          // Render a countdown
          return (
            <span>
              ({seconds})
            </span>
          );
        }
    };
    
    const validarPagamento = (forma) => {
        intervalPagamento.current = setInterval(() => {
            situacaoPagamento(venda.proposta, (response) => {
                if (response === 200) {
                    clearInterval(intervalPagamento.current);
                    intervalPagamento.current = null;

                    setPagamentoEfetuado(1);
                } else if (response === 300) {
                    setPagamentoEfetuado(forma === "CR" ? 2 : 0);
                } else if (response === 301) {
                    clearInterval(intervalPagamento.current);
                    intervalPagamento.current = null;

                    setPagamentoEfetuado(7);
                }
            });
        }, 5000);
    }

    const validarPagamentoNovo = (forma) => {
        console.log("Iniciando validação pagamento", forma);
        intervalPagamento.current = setInterval(() => {
            situacaoPagamentoNovo(venda.nsu, (response) => {
                console.log("Resposta situação pagamento", venda.nsu, response);

                if (response === 200) {
                    clearInterval(intervalPagamento.current);
                    intervalPagamento.current = null;

                    setPagamentoEfetuado(1);
                } else if (response === 300) {
                    setPagamentoEfetuado(forma === "CR" ? 2 : 0);
                } else if (response === 301) {
                    clearInterval(intervalPagamento.current);
                    intervalPagamento.current = null;

                    setPagamentoEfetuado(7);
                }
            });
        }, 5000);
    }
    
    const onShowConfirmarPagamento = (forma) => {
        if (intervalPagamento.current) return;

        if (pagamentoEfetuado === 0) {
            validarPagamento(forma);
        }
    }

    const onShowConfirmarPagamentoNovo = (forma) => {
        if (intervalPagamento.current) return;

        if (pagamentoEfetuado === 0) {
            validarPagamentoNovo(forma);
        }
    }
    
    const stopIntervalPagamento = () => {
        if (intervalPagamento.current) {
            clearInterval(intervalPagamento.current);
            intervalPagamento.current = null;
        }
    }
    
    const onHideConfirmarPagamento = (forma) => {
        stopIntervalPagamento();
        
        if (forma === "PX") {
            // VINDI
            //setModalPagamentoPix(false);
            setModalPagamentoPixNovo(false);
        }
        else {
            // VINDI
            //setModalPagamentoCartao(false);
            setModalPagamentoCartaoNovo(false);
        }
    }
    
    const onCopiarPix = async () => {
        await navigator.clipboard.writeText(venda.pix);
        alert("Código PIX copiado!");
    }
    
    return (
        <>
            {loading &&
                <>
                    <div className="d-flex flex-column w-100 align-items-center">
                        <div className="d-flex flex-column align-items-center" style={{ width: "1150px" }}>
                            <div className="d-flex flex-column" style={{ width: "100%" }}>
                                <div className="d-flex flex-row justify-content-between" style={{ width: "100%", marginTop: "1px"}}>
                                    <Skeleton count={1} height={"90px"} width={"230px"}/>
                                    <Skeleton count={1} height={"90px"} width={"230px"}/>
                                </div>
                                <span style={{marginTop: "40px"}}></span>
                                <Skeleton count={1} height={"40px"} width={"180px"} style={{borderRadius: "15px 15px 0px 0px"}}/>
                                <Skeleton count={20} height={"20px"}/>
                            </div>
                        </div>
                    </div>
                </>
            }

            {venda && !loading &&
                <>
                    <div className="d-flex flex-column w-100 align-items-center">
                        <LoadingMask loading={loadingMask.atualizaVenda} text={"Aguarde..."}>
                        <div className="d-flex flex-column bg-padrao align-items-center" style={{ width: "1150px" }}>
                            <div className="d-flex flex-row justify-content-between w-100">
                                <div style={{ marginLeft: "10px", marginTop: "10px" }}>
                                    <img src={rapidex} alt=""></img>
                                </div>
                                <img src={caixaAssistencia} alt=""></img>
                            </div>

                            <div className="d-flex flex-column mb-4" style={{ marginTop: "40px", width: "98%" }}>
                                <Tabs selectedTabClassName="tabPadrao" selectedIndex={tabIndex}>
                                    <TabList>
                                        <Tab disabled={tabIndex === 1}>Dados do Produto</Tab>
                                        <Tab disabled={tabIndex === 0}>Confirmação</Tab>
                                    </TabList>

                                    <TabPanel style={{ padding: "0px 10px", border: "1px solid #aaa" }}>
                                        <div className="d-flex flex-column w-100">
                                            <div className="d-flex flex-column w-100 justify-content-end">
                                                <div style={{ fontSize: "11px", fontWeight: "bold", color: "#759cc2", alignSelf: "flex-end" }}>
                                                    Os campos marcados com * são de preenchimento obrigatório.
                                                </div>
                                            </div>

                                            <div className="d-flex flex-column w-100">
                                                <div className="d-flex flex-row w-100 justify-content-between" style={{ borderBottom: "1px dashed #759cc2", height: "40px" }}>
                                                    <div style={{ color: "#759cc2", alignSelf: "flex-end" }}>
                                                        Indicador
                                                    </div>
                                                </div>

                                                <div className="d-flex flex-row w-100 align-items-start">
                                                    <div className="d-flex flex-column" style={{ width: "150px" }}>
                                                        <label htmlFor="tbxAgenciaVendedor" className="form-label colorTextoPadrao">Agência *</label>
                                                        <input type="text"
                                                            className="form-control"
                                                            id="tbxAgenciaVendedor"
                                                            name="agenciaVendedor"
                                                            value={venda.vendedor.agencia}
                                                            onChange={(e) => onAtualiza(e)}
                                                            onBlur={(e) => onSelecionaAgencia(e)}></input>
                                                        <div className="erros">
                                                            {validacao?.agenciaDigitadaErro && <span>{validacao?.agenciaDigitadaErro}</span>}
                                                        </div>
                                                    </div>

                                                    <div className="d-flex flex-column ms-3" style={{ width: "410px" }}>
                                                        <label htmlFor="tbxNomeAgencia" className="form-label colorTextoPadrao">Nome da Agência</label>
                                                        <input type="text"
                                                            className="form-control"
                                                            id="tbxNomeAgencia"
                                                            name="nomeAgencia"
                                                            value={venda.vendedor.nomeAgencia}
                                                            readOnly={true}></input>
                                                    </div>

                                                    {venda.formaVenda.toUpperCase() !== "CCA" &&
                                                    <div className="d-flex flex-column ms-3" style={{ width: "150px" }}>
                                                        <label htmlFor="tbxMatriculaVendedor" className="form-label colorTextoPadrao">Matrícula *</label>
                                                        <input type="text"
                                                            className="form-control"
                                                            id="tbxMatriculaVendedor"
                                                            name="matriculaVendedor"
                                                            value={venda.vendedor.matricula}
                                                            onChange={(e) => onAtualiza(e)}
                                                            onBlur={(e) => onSelecionaEmpregado(e)}></input>
                                                        <div className="erros">
                                                            {validacao?.empregadoErro && <span>{validacao?.empregadoErro}</span>}
                                                        </div>
                                                    </div>
                                                    }

                                                    {venda.formaVenda.toUpperCase() !== "CCA" &&
                                                    <div className="d-flex flex-column ms-3" style={{ width: "410px" }}>
                                                        <label htmlFor="tbxNomeVendedor" className="form-label colorTextoPadrao">Empregado</label>
                                                        <input type="text"
                                                            className="form-control"
                                                            id="tbxNomeVendedor"
                                                            name="nome"
                                                            value={venda.vendedor.nome}
                                                            readOnly={true}></input>
                                                    </div>
                                                    }
                                                </div>
                                            </div>

                                            <div className="d-filex flex-col w-100">
                                                <label htmlFor="ddlTipoProduto" className="form-label colorTextoPadrao">Escolha um dos produtos abaixo *</label>
                                                <select className="form-select"
                                                    name="tipo_produto"
                                                    value={venda.tipo_produto} 
                                                    onChange={(e) => onAtualizaProduto(e)}>
                                                    <option value="">Escolha uma opção</option>
                                                    {venda?.ofertar === "F" &&
                                                        <>
                                                        <option value="RAPIDEX">Rapidex + Cuidado</option>
                                                        {venda?.sexo === "F" &&
                                                            <option value="MULHER">Rapidex Mulher</option>
                                                        }
                                                        <option value="RAPIDEX_MOB">Rapidex + tagCaixa</option>
                                                        {!venda?.maiorIgual70 &&
                                                            <option value="RAPIDEX_BEM">Rapidex do Bem</option>
                                                        }
                                                        </>
                                                    }
                                                    {venda?.ofertar === "J" &&
                                                        <>
                                                        <option value="MEI">Rapidex MEI</option>
                                                        </>
                                                    }
                                                    {venda?.ofertar === "A" &&
                                                        <>
                                                        <option value="RAPIDEX">Rapidex + Cuidado</option>                                                        
                                                        <option value="MEI">Rapidex MEI</option>

                                                        {venda?.sexo === "F" &&
                                                            <option value="MULHER">Rapidex Mulher</option>
                                                        }
                                                        <option value="RAPIDEX_MOB">Rapidex + tagCaixa</option>
                                                        {!venda?.maiorIgual70 &&
                                                            <option value="RAPIDEX_BEM">Rapidex do Bem</option>
                                                        }
                                                        </>
                                                    }
                                                </select>
                                            </div>

                                            <Modal show={popupTag} centered={true}>
                                                <Modal.Header className="cabecalho_modal">
                                                    Atenção aos dados!
                                                </Modal.Header>
                                                <Modal.Body>
                                                    <div className="w-100">
                                                        <p className='mb-0'>Confira e atualize com atenção as informações preenchidas no momento da compra.</p>
                                                        <p>Elas serão utilizadas quando o cliente solicitar a tagCAIXA e devem estar corretas para garantir o funcionamento do serviço.</p> 
                                                    </div>
                                                </Modal.Body>
                                                <Modal.Footer>
                                                    <div className="d-flex flex-row">
                                                        <button type="button" className="botaoLaranja" style={{width: "110px"}} onClick={() => setPopupTag(false)}>Fechar</button>
                                                    </div>
                                                </Modal.Footer>
                                            </Modal> 

                                            <div className="erros">
                                                {validacao?.modalidadeErro && <span>{validacao?.modalidadeErro}</span>}
                                            </div>

                                            <div className="d-flex flex-row w-100 justify-content-between" style={{ borderBottom: "1px dashed #759cc2", height: "40px" }}>
                                                <div style={{ color: "#759cc2", alignSelf: "flex-end" }}>
                                                    <b>Confirme alguns dados do cliente</b>
                                                </div>
                                            </div>

                                            <div className="d-flex flex-row">
                                                <div className="d-flex flex-column" style={{ marginTop: "20px", marginRight: "20px" }}>
                                                    <label htmlFor="tbxNome" className="form-label colorTextoPadrao">Nome *</label>
                                                    <input type="text"
                                                        className="form-control"
                                                        id="tbxNome"
                                                        style={{ width: "400px" }}
                                                        name="nome"
                                                        value={venda.nome}
                                                        onChange={(e) => onAtualiza(e)}
                                                        readOnly={true}></input>
                                                </div>

                                                <div className="d-flex flex-column" style={{ marginTop: "20px" }}>
                                                    <label htmlFor="tbxEmail" className="form-label colorTextoPadrao">E-mail <span className="colorTextoCinzaEscuro">(editável)</span></label>
                                                    <input type="text"
                                                        className="form-control"
                                                        id="tbxEmail"
                                                        name="email"
                                                        value={venda.email}
                                                        onChange={(e) => onAtualiza(e)}
                                                        style={{ width: "500px" }}></input>
                                                    <div className="erros">
                                                        {validacao?.emailErro && <span>{validacao?.emailErro}</span>}
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="d-flex flex-row">
                                                <div className="d-flex flex-column" style={{ marginTop: "20px", marginRight: "20px" }}>
                                                    <label htmlFor="tbxCPF" className="form-label colorTextoPadrao">CPF/CNPJ *</label>
                                                    <input type="text"
                                                        className="form-control"
                                                        id="tbxCPF"
                                                        style={{ width: "400px" }}
                                                        name="cpf"
                                                        value={venda.cpfMask}
                                                        onChange={(e) => onAtualiza(e)}
                                                        readOnly={true}></input>
                                                </div>

                                                <div className="d-flex flex-column" style={{ marginTop: "20px" }}>
                                                    <label htmlFor="tbxEmailConfirma" className="form-label colorTextoPadrao">Confirmação E-mail <span className="colorTextoCinzaEscuro">(editável)</span></label>
                                                    <input type="text"
                                                        className="form-control"
                                                        id="tbxEmailConfirma"
                                                        name="emailConfirmacao"
                                                        value={venda.emailConfirmacao}
                                                        onChange={(e) => onAtualiza(e)}
                                                        style={{ width: "500px" }}></input>
                                                    <div className="erros">
                                                        {validacao?.emailConfirmacaoErro && <span>{validacao?.emailConfirmacaoErro}</span>}
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="d-flex flex-column" style={{ marginTop: "20px" }}>
                                                <label htmlFor="tbxCelular" className="form-label colorTextoPadrao">Celular * <span className="colorTextoCinzaEscuro">(editável)</span></label>
                                                <IMaskInput className="form-control"
                                                    id="tbxCelular"
                                                    mask="(00) 00000-0000"
                                                    name="celular"
                                                    value={venda.celular}
                                                    onChange={(e) => onAtualiza(e)}
                                                    onBlur={(e) => onAtualiza(e)}
                                                    style={{ width: "300px" }}></IMaskInput>
                                                <div className="erros">
                                                    {validacao?.celularErro && <span>{validacao?.celularErro}</span>}
                                                </div>
                                            </div>

                                            <div className="d-flex flex-column" style={{ marginTop: "20px" }}>
                                                <label htmlFor="tbxLogradouroCep" className="form-label colorTextoPadrao">CEP * <span className="colorTextoCinzaEscuro">(editável)</span></label>
                                                <IMaskInput className="form-control"
                                                    id="tbxLogradouroCep"
                                                    mask="00000-000"
                                                    name="logradouroCep"
                                                    value={venda.logradouro.cep}
                                                    onChange={(e) => onAtualiza(e)}
                                                    onBlur={(e) => onAtualizaCep(e)}
                                                    style={{ width: "300px" }}></IMaskInput>
                                                <div className="erros">
                                                    {validacao?.logradouroCepErro && <span>{validacao?.logradouroCepErro}</span>}
                                                </div>
                                            </div>

                                            <div className="d-flex flex-row">
                                                <div className="d-flex flex-column" style={{ marginTop: "20px", marginRight: "20px" }}>
                                                    <label htmlFor="tbxLogradouroEndereco" className="form-label colorTextoPadrao">ENDERECO * <span className="colorTextoCinzaEscuro">(editável)</span></label>
                                                    <input type="text"
                                                        className="form-control"
                                                        id="tbxLogradouroEndereco"
                                                        value={venda.logradouro.endereco}
                                                        style={{ width: "550px" }}
                                                        name="logradouroEndereco"
                                                        maxLength={200}
                                                        readOnly={venda.logradouro.endereco.trim() != ""}
                                                        onChange={(e) => onAtualiza(e)}></input>
                                                    <div className="erros">
                                                        {validacao?.logradouroEnderecoErro && <span>{validacao?.logradouroEnderecoErro}</span>}
                                                    </div>
                                                </div>

                                                <div className="d-flex flex-column" style={{ marginTop: "20px", marginRight: "20px" }}>
                                                    <label htmlFor="tbxLogradouroNumero" className="form-label colorTextoPadrao">Número * <span className="colorTextoCinzaEscuro">(editável)</span></label>
                                                    <input type="text"
                                                        className="form-control"
                                                        id="tbxLogradouroNumero"
                                                        name="logradouroNumero"
                                                        maxLength={10}
                                                        value={venda.logradouro.numero}
                                                        onChange={(e) => onAtualiza(e)}
                                                        style={{ width: "200px" }}></input>
                                                    <div className="erros">
                                                        {validacao?.logradouroNumeroErro && <span>{validacao?.logradouroNumeroErro}</span>}
                                                    </div>
                                                </div>

                                                <div className="d-flex flex-column" style={{ marginTop: "20px" }}>
                                                    <label htmlFor="tbxLogradouroComplemento" className="form-label colorTextoPadrao">Complemento</label>
                                                    <input type="text"
                                                        className="form-control"
                                                        id="tbxLogradouroComplemento"
                                                        name="logradouroComplemento"
                                                        maxLength={35}
                                                        value={venda.logradouro.complemento}
                                                        onChange={(e) => onAtualiza(e)}
                                                        style={{ width: "300px" }}></input>
                                                </div>
                                            </div>

                                            <div className="d-flex flex-row">
                                                <div className="d-flex flex-column" style={{ marginTop: "20px", marginRight: "20px" }}>
                                                    <label htmlFor="tbxLogradouroBairro" className="form-label colorTextoPadrao">Bairro * <span className="colorTextoCinzaEscuro">(editável)</span></label>
                                                    <input type="text"
                                                        className="form-control"
                                                        id="tbxLogradouroBairro"
                                                        value={venda.logradouro.bairro}
                                                        style={{ width: "350px" }}
                                                        name="logradouroBairro"
                                                        maxLength={60}
                                                        readOnly={venda.logradouro.bairro.trim() != ""}
                                                        onChange={(e) => onAtualiza(e)}></input>
                                                    <div className="erros">
                                                        {validacao?.logradouroBairroErro && <span>{validacao?.logradouroBairroErro}</span>}
                                                    </div>
                                                </div>

                                                <div className="d-flex flex-column" style={{ marginTop: "20px", marginRight: "20px" }}>
                                                    <label htmlFor="tbxLogradouroCidade" className="form-label colorTextoPadrao">Cidade * <span className="colorTextoCinzaEscuro">(editável)</span></label>
                                                    <input type="text"
                                                        className="form-control"
                                                        id="tbxLogradouroCidade"
                                                        name="logradouroCidade"
                                                        value={venda.logradouro.cidade}
                                                        maxLength={50}
                                                        readOnly={venda.logradouro.cidade.trim() != ""}
                                                        onChange={(e) => onAtualiza(e)}
                                                        style={{ width: "350px" }}></input>
                                                    <div className="erros">
                                                        {validacao?.logradouroCidadeErro && <span>{validacao?.logradouroCidadeErro}</span>}
                                                    </div>
                                                </div>

                                                <div className="d-flex flex-column" style={{ marginTop: "20px" }}>
                                                    <label htmlFor="tbxLogradouroEstado" className="form-label colorTextoPadrao">Estado * <span className="colorTextoCinzaEscuro">(editável)</span></label>
                                                    <select className="form-select"
                                                        name="logradouroEstado"
                                                        id="tbxLogradouroEstado"
                                                        value={venda.logradouro.uf}
                                                        disabled={venda.logradouro.uf.trim() != ""}
                                                        onChange={(e) => onAtualiza(e)}
                                                        style={{ width: "350px" }}>
                                                        <option value=""></option>
                                                        <option value="AC">Acre</option>
                                                        <option value="AL">Alagoas</option>
                                                        <option value="AP">Amapá</option>
                                                        <option value="AM">Amazonas</option>
                                                        <option value="BA">Bahia</option>
                                                        <option value="CE">Ceará</option>
                                                        <option value="ES">Espírito Santo</option>
                                                        <option value="GO">Goiás</option>
                                                        <option value="MA">Maranhão</option>
                                                        <option value="MT">Mato Grosso</option>
                                                        <option value="MS">Mato Grosso do Sul</option>
                                                        <option value="MG">Minas Gerais</option>
                                                        <option value="PA">Pará</option>
                                                        <option value="PB">Paraíba</option>
                                                        <option value="PR">Paraná</option>
                                                        <option value="PE">Pernambuco</option>
                                                        <option value="PI">Piauí</option>
                                                        <option value="RJ">Rio de Janeiro</option>
                                                        <option value="RN">Rio Grande do Norte</option>
                                                        <option value="RS">Rio Grande do Sul</option>
                                                        <option value="RO">Rondônia</option>
                                                        <option value="RR">Roraima</option>
                                                        <option value="SC">Santa Catarina</option>
                                                        <option value="SP">São Paulo</option>
                                                        <option value="SE">Sergipe</option>
                                                        <option value="TO">Tocantins</option>
                                                    </select>
                                                    <div className="erros">
                                                        {validacao?.logradouroEstadoErro && <span>{validacao?.logradouroEstadoErro}</span>}
                                                    </div>
                                                </div>
                                            </div>

                                            {venda && venda?.tipo_produto !== "" &&
                                                <>
                                                    <div className="d-flex flex-column" style={{ marginTop: "20px", borderBottom: "1px dashed #759cc2" }}>
                                                        {venda?.tipo_produto === "MEI" &&
                                                            <>
                                                                <div className="d-flex flex-column" style={{ marginTop: "20px", borderBottom: "1px dashed #759cc2" }}>
                                                                    <label className="form-label colorTextoPadrao">Plano</label>

                                                                    <div className="d-flex flex-row">
                                                                        {venda?.contas && venda?.contas?.length > 0 &&
                                                                            <div className="form-check" style={{ marginRight: "20px" }}>
                                                                                <input className="form-check-input colorTextoPadrao"
                                                                                    type="radio"
                                                                                    name="produto"
                                                                                    id="produto_mensal"
                                                                                    value="MEI_MENSAL"
                                                                                    checked={venda.modalidade === "MEI_MENSAL"}
                                                                                    onChange={(e) => onAtualizaModalidade(e)}></input>
                                                                                <label className="form-check-label colorTextoPadrao" htmlFor="produto_mensal">
                                                                                    Mensal
                                                                                </label>
                                                                            </div>
                                                                        }
                                                                        <div className="form-check" style={{ marginRight: "20px" }}>
                                                                            <input className="form-check-input colorTextoPadrao"
                                                                                type="radio"
                                                                                name="produto"
                                                                                id="produto_semestral"
                                                                                value="MEI_SEMESTRAL"
                                                                                checked={venda.modalidade === "MEI_SEMESTRAL"}
                                                                                onChange={(e) => onAtualizaModalidade(e)}></input>
                                                                            <label className="form-check-label colorTextoPadrao" htmlFor="produto_semestral">
                                                                                Semestral
                                                                            </label>
                                                                        </div>

                                                                        <div className="form-check" style={{ marginRight: "20px" }}>
                                                                            <input className="form-check-input colorTextoPadrao"
                                                                                type="radio"
                                                                                name="produto"
                                                                                id="produto_mei_anual"
                                                                                value="MEI_ANUAL"
                                                                                checked={venda.modalidade === "MEI_ANUAL"}
                                                                                onChange={(e) => onAtualizaModalidade(e)}></input>
                                                                            <label className="form-check-label colorTextoPadrao" htmlFor="produto_mei_anual">
                                                                                Anual
                                                                            </label>
                                                                        </div>

                                                                    </div>

                                                                    <div className="erros">
                                                                        {validacao?.planoErro && <span>{validacao?.planoErro}</span>}
                                                                    </div>
                                                                </div>
                                                            </>
                                                        }

                                                        {venda?.tipo_produto === "MULHER" &&
                                                            <>
                                                                <label className="form-label colorTextoPadrao">Plano</label>

                                                                <div className="d-flex flex-row">
                                                                    <div className="form-check" style={{ marginRight: "20px" }}>
                                                                        <input className="form-check-input colorTextoPadrao"
                                                                            type="radio"
                                                                            name="produto"
                                                                            id="produto_semestral"
                                                                            value="MULHER_SEMESTRAL"
                                                                            checked={venda.modalidade === "MULHER_SEMESTRAL"}
                                                                            onChange={(e) => onAtualizaModalidade(e)}></input>
                                                                        <label className="form-check-label colorTextoPadrao" htmlFor="produto_semestral">
                                                                            Semestral
                                                                        </label>
                                                                    </div>

                                                                    <div className="form-check">
                                                                        <input className="form-check-input colorTextoPadrao"
                                                                            type="radio"
                                                                            name="produto"
                                                                            id="produto_mulher_anual"
                                                                            value="MULHER_ANUAL"
                                                                            checked={venda.modalidade === "MULHER_ANUAL"}
                                                                            onChange={(e) => onAtualizaModalidade(e)}></input>
                                                                        <label className="form-check-label colorTextoPadrao" htmlFor="produto_mulher_anual">
                                                                            Anual
                                                                        </label>
                                                                    </div>
                                                                </div>

                                                                <div className="erros">
                                                                    {validacao?.planoErro && <span>{validacao?.planoErro}</span>}
                                                                </div>
                                                            </>
                                                        }

                                                        {venda?.tipo_produto === "RAPIDEX" &&
                                                            <>
                                                                <div className="d-flex flex-column" style={{ marginTop: "20px", borderBottom: "1px dashed #759cc2" }}>
                                                                    <label className="form-label colorTextoPadrao">Plano</label>

                                                                    <div className="d-flex flex-row">
                                                                        {venda?.contas && venda?.contas?.length > 0 &&
                                                                            <div className="form-check" style={{ marginRight: "20px" }}>
                                                                                <input className="form-check-input colorTextoPadrao"
                                                                                    type="radio"
                                                                                    name="produto"
                                                                                    id="produto_mensal"
                                                                                    value="MENSAL"
                                                                                    checked={venda.modalidade === "MENSAL"}
                                                                                    onChange={(e) => onAtualizaModalidade(e)}></input>
                                                                                <label className="form-check-label colorTextoPadrao" htmlFor="produto_mensal">
                                                                                    Mensal
                                                                                </label>
                                                                            </div>
                                                                        }
                                                                        <div className="form-check" style={{ marginRight: "20px" }}>
                                                                            <input className="form-check-input colorTextoPadrao"
                                                                                type="radio"
                                                                                name="produto"
                                                                                id="produto_semestral"
                                                                                value="SEMESTRAL"
                                                                                checked={venda.modalidade === "SEMESTRAL"}
                                                                                onChange={(e) => onAtualizaModalidade(e)}></input>
                                                                            <label className="form-check-label colorTextoPadrao" htmlFor="produto_semestral">
                                                                                Semestral
                                                                            </label>
                                                                        </div>

                                                                        <div className="form-check" style={{ marginRight: "20px" }}>
                                                                            <input className="form-check-input colorTextoPadrao"
                                                                                type="radio"
                                                                                name="produto"
                                                                                id="produto_anual"
                                                                                value="ANUAL"
                                                                                checked={venda.modalidade === "ANUAL"}
                                                                                onChange={(e) => onAtualizaModalidade(e)}></input>
                                                                            <label className="form-check-label colorTextoPadrao" htmlFor="produto_anual">
                                                                                Anual
                                                                            </label>
                                                                        </div>
                                                                        
                                                                        <div className="form-check">
                                                                                <input className="form-check-input colorTextoPadrao"
                                                                                    type="radio"
                                                                                    name="produto"
                                                                                    id="produto_plurianual"
                                                                                    value="PLURIANUAL"
                                                                                    checked={venda.modalidade === "PLURIANUAL"}
                                                                                    onChange={(e) => onAtualizaModalidade(e)}></input>
                                                                                <label className="form-check-label colorTextoPadrao" htmlFor="produto_plurianual">
                                                                                    Plurianual (36 meses)
                                                                                </label>
                                                                        </div>

                                                                    </div>

                                                                    <div className="erros">
                                                                        {validacao?.planoErro && <span>{validacao?.planoErro}</span>}
                                                                    </div>
                                                                </div>
                                                            </>
                                                        } 
                                      
                                                        {venda?.tipo_produto === "RAPIDEX_MOB" &&
                                                            <>
                                                                <div className="d-flex flex-column" style={{ marginTop: "20px", borderBottom: "1px dashed #759cc2" }}>
                                                                    <label className="form-label colorTextoPadrao">Plano</label>

                                                                    <div className="d-flex flex-row">
                                                                        <div className="form-check" style={{ marginRight: "20px" }}>
                                                                            <input className="form-check-input colorTextoPadrao"
                                                                                type="radio"
                                                                                name="produto_mob"
                                                                                id="produto_mob_semestral"
                                                                                value="SEMESTRAL_MOB"
                                                                                checked={venda.modalidade === "SEMESTRAL_MOB"}
                                                                                onChange={(e) => onAtualizaModalidade(e)}></input>
                                                                            <label className="form-check-label colorTextoPadrao" htmlFor="produto_mob_semestral">
                                                                                Semestral
                                                                            </label>
                                                                        </div>
                                                                    </div>

                                                                    <div className="erros">
                                                                        {validacao?.planoErro && <span>{validacao?.planoErro}</span>}
                                                                    </div>
                                                                </div>
                                                            </>
                                                        }

                                                        {venda?.tipo_produto === "RAPIDEX_BEM" &&
                                                            <>
                                                                <div className="d-flex flex-column" style={{ marginTop: "20px", borderBottom: "1px dashed #759cc2" }}>
                                                                    <label className="form-label colorTextoPadrao">Plano</label>

                                                                    <div className="d-flex flex-row">
                                                                        <div className="form-check" style={{ marginRight: "20px" }}>
                                                                            <input className="form-check-input colorTextoPadrao"
                                                                                type="radio"
                                                                                name="produto"
                                                                                id="produto_semestral"
                                                                                value="SEMESTRAL_BEM"
                                                                                checked={venda.modalidade === "SEMESTRAL_BEM"}
                                                                                onChange={(e) => onAtualizaModalidade(e)}></input>
                                                                            <label className="form-check-label colorTextoPadrao" htmlFor="produto_semestral">
                                                                                Semestral
                                                                            </label>
                                                                        </div>

                                                                        <div className="form-check" style={{ marginRight: "20px" }}>
                                                                            <input className="form-check-input colorTextoPadrao"
                                                                                type="radio"
                                                                                name="produto"
                                                                                id="produto_anual_bem"
                                                                                value="ANUAL_BEM"
                                                                                checked={venda.modalidade === "ANUAL_BEM"}
                                                                                onChange={(e) => onAtualizaModalidade(e)}></input>
                                                                            <label className="form-check-label colorTextoPadrao" htmlFor="produto_anual_bem">
                                                                                Anual
                                                                            </label>
                                                                        </div>
                                                                    </div>

                                                                    <div className="erros">
                                                                        {validacao?.planoErro && <span>{validacao?.planoErro}</span>}
                                                                    </div>
                                                                </div>
                                                            </>
                                                        }
                                                    </div>

                                                    <div className="d-flex flex-column">
                                                        <div className="colorTextoPadrao" style={{ marginTop: "10px" }}>
                                                            Pagamento da primeira parcela
                                                        </div>

                                                        <div className="d-flex flex-row" style={{ borderBottom: "1px dashed #759cc2" }}>
                                                            <div className="form-check" style={{ marginRight: "20px" }}>
                                                                <input className="form-check-input colorTextoPadrao"
                                                                    type="radio"
                                                                    name="pagamento"
                                                                    value="BL"
                                                                    checked={venda.pagamento === "BL"}
                                                                    onChange={(e) => onAtualizaPagamento(e)}
                                                                    id="boleto"></input>
                                                                <label className="form-check-label colorTextoPadrao" htmlFor="boleto">
                                                                    Boleto
                                                                </label>
                                                            </div>

                                                            {venda?.contas && venda?.contas?.length > 0 &&
                                                                <div className="form-check" style={{ marginRight: "20px" }}>
                                                                    <input className="form-check-input colorTextoPadrao"
                                                                        type="radio"
                                                                        name="pagamento"
                                                                        value="DB"
                                                                        checked={venda.pagamento === "DB"}
                                                                        onChange={(e) => onAtualizaPagamento(e)}
                                                                        id="debito"></input>
                                                                    <label className="form-check-label colorTextoPadrao" htmlFor="debito">
                                                                        Débito em conta
                                                                    </label>
                                                                </div>
                                                            }
                                                                
                                                            <div className="form-check" style={{ marginRight: "20px" }}>
                                                                <input className="form-check-input colorTextoPadrao"
                                                                    type="radio"
                                                                    name="pagamento"
                                                                    value="PX"
                                                                    checked={venda.pagamento === "PX"}
                                                                    onChange={(e) => onAtualizaPagamento(e)}
                                                                    id="pix"></input>
                                                                <label className="form-check-label colorTextoPadrao" htmlFor="pix">
                                                                    Pix
                                                                </label>
                                                            </div>

                                                            {(venda?.modalidade?.toUpperCase() !== "MEI_ANUAL" &&
                                                                venda?.modalidade?.toUpperCase() !== "MULHER_ANUAL" &&
                                                                venda?.modalidade?.toUpperCase() !== "ANUAL" &&
                                                                venda?.modalidade?.toUpperCase() !== "PLURIANUAL" &&
                                                                venda?.modalidade?.toUpperCase() !== "ANUAL_BEM") &&
                                                                <div className="form-check" style={{ marginRight: "20px" }}>
                                                                    <input className="form-check-input colorTextoPadrao"
                                                                        type="radio"
                                                                        name="pagamento"
                                                                        value="CR"
                                                                        checked={venda.pagamento === "CR"}
                                                                        onChange={(e) => onAtualizaPagamento(e)}
                                                                        id="cartao_credito"></input>
                                                                    <label className="form-check-label colorTextoPadrao" htmlFor="cartao_credito">
                                                                        Cartão de Crédito
                                                                    </label>
                                                                </div>
                                                            }
                                                        </div>

                                                        {    
                                                            (venda?.pagamento === "CR" && venda?.renovacaoAutomatica === "S" && (venda?.modalidade === "MEI_SEMESTRAL" || venda?.modalidade === "MULHER_SEMESTRAL" || venda?.modalidade === "SEMESTRAL" || venda?.modalidade === "SEMESTRAL_BEM")) &&
                                                                <div className="colorTextoPadrao" style={{ marginTop: "10px" }}>O seu Rapidex será renovado automaticamente a cada 6 meses, com o valor debitado diretamente do seu cartão de crédito. Caso deseje cancelar, basta entrar em contato com a nossa central de atendimento no número 0800 775 4085.</div>
                                                        }

                                                        <div className="erros">
                                                            {validacao?.pagamentoErro && <span>{validacao?.pagamentoErro}</span>}
                                                        </div>
                                                    </div>

                                                    {venda?.modalidade && venda?.modalidade !== "" && venda?.contas && venda?.contas?.length > 0 &&
                                                            <>
                                                                {venda?.modalidade !== "MENSAL" && 
                                                                 venda?.modalidade !== 'PLURIANUAL' && 
                                                                 venda?.modalidade !== "MEI_MENSAL" && 
                                                                 venda?.modalidade !== "SEMESTRAL_BEM" && 
                                                                 venda?.modalidade !== "ANUAL_BEM" &&
                                                                 venda?.tipo_produto !== "RAPIDEX_MOB" ?
                                                                    <>
                                                                        <div className="form-check colorTextoPadrao" style={{ marginRight: "20px" }}>
                                                                            <input className="form-check-input"
                                                                                type="checkbox"
                                                                                name="renovacaoAutomatica"
                                                                                id="renovacao_automatica"
                                                                                checked={venda.renovacaoAutomatica === "S"}
                                                                                onChange={(e) => onAtualizaRenovacaoAutomatica(e)}></input>
                                                                            <label className="form-check-label colorTextoPadrao" htmlFor="renovacao_automatica">
                                                                                Renovação Simplificada?
                                                                            </label>
                                                                        </div>

                                                                        <div className="colorTextoPadrao" style={{ marginLeft: "25px" }}>
                                                                            <div>Com a renovação simplificada, o produto vai ser renovado de forma simples sempre que seu plano estiver terminando. A cobrança será feita {venda.pagamento !== "CR" ? <>direto na Conta Corrente</> : <>em seu cartão de credito</>} , sem precisar se preocupar com data de vencimento, sem sair de casa e tendo sempre a segurança que só o RAPIDEX pode oferecer.</div>
                                                                            <div>Ah, não se preocupe! Sempre vamos avisar com 60 e 30 dias de antecedência que está chegando a data da renovação ;)</div>
                                                                            <div>O cliente pode solicitar o cancelamento a qualquer momento, basta ligar na nossa central 0800 775 4085.</div>
                                                                        </div>
                                                                    </>
                                                                    :
                                                                    <>
                                                                        {venda?.modalidade !== 'PLURIANUAL' && venda?.modalidade !== '' && venda?.modalidade !== "SEMESTRAL_BEM" && venda?.modalidade !== "ANUAL_BEM" && venda?.modalidade !== "SEMESTRAL" &&  venda?.modalidade !== "SEMESTRAL_MOB" &&
                                                                            <>
                                                                                <div className="form-check" style={{ marginRight: "20px" }}>
                                                                                    <input className="form-check-input"
                                                                                        type="checkbox"
                                                                                        name="debitoDemaisParcelas"
                                                                                        id="debito_demais_parcelas"
                                                                                        checked={venda.debitoDemaisParcelas === "S"}
                                                                                        onChange={(e) => onAtualizaDebitoDemaisParcelas(e)}></input>
                                                                                    <label className="form-check-label colorTextoPadrao" htmlFor="debito_demais_parcelas">
                                                                                        {(venda?.pagamento !== "CR") ?
                                                                                        <>
                                                                                        Autorizo o débito das demais parcelas na conta identificada abaixo.
                                                                                        </>
                                                                                        :
                                                                                        <>
                                                                                        Autorizo o débito das parcelas futuras no cartão de crédito mensalmente. O valor será cobrado conforme o vencimento de cada parcela, de forma contínua e segura.
                                                                                        </>
                                                                                        }
                                                                                    </label>
                                                                                </div>

                                                                                {validacao?.debitoAutomaticoErro &&
                                                                                    <div className="erros" style={{ marginLeft: "25px" }}>
                                                                                        {validacao?.debitoAutomaticoErro && <span>{validacao?.debitoAutomaticoErro}</span>}
                                                                                    </div>
                                                                                }
                                                                            </>
                                                                        }
                                                                    </>
                                                                }
                                                            </>
                                                        }

                                                    {venda?.pagamento !== "CR" && (venda?.pagamento === "DB" || venda?.renovacaoAutomatica === "S" || venda?.debitoDemaisParcelas === "S") &&
                                                        <div className="d-flex flex-column w-100">
                                                            <div className="d-flex flex-row w-100" style={{ marginTop: "15px" }}>
                                                                <div className="d-flex flex-column" style={{ width: "55%" }}>
                                                                    <div className="colorTextoPadrao" style={{ marginTop: "2px"}}>
                                                                        O valor será debitado da conta corrente ao fim de cada vigência.
                                                                    </div>

                                                                    <div className="colorTextoPadrao">
                                                                        Escolha uma das contas abaixo para os futuros débitos
                                                                    </div>

                                                                    <div>
                                                                        <select className="form-select"
                                                                            name="id"
                                                                            value={venda.conta_pagamento.id}
                                                                            onChange={(e) => onSelecionaConta(e)}>
                                                                            <option key={"0"} value="">{(venda.conta_pagamento.id === "" && venda.conta_pagamento.agencia === "") ? "Selecione uma conta" : ""}</option>
                                                                            {venda && venda.contas && venda.contas.map(conta => {
                                                                                return (
                                                                                    <option key={conta.id} value={conta.id}>{conta.conta}</option>
                                                                                )
                                                                            })};
                                                                        </select>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            <div className="erros">
                                                                {validacao?.contaErro && <span>{validacao?.contaErro}</span>}
                                                            </div>

                                                        </div>
                                                    }
                                                    
                                                    {!readOnlyDataPagamento &&
                                                        <div className="d-flex flex-column" style={{ marginTop: "10px" }}>
                                                            <label htmlFor="tbxDataPagamento" className="form-label colorTextoPadrao">Data Pagamento * <span className="colorTextoCinzaEscuro">(editável)</span></label>
                                                            <div className="d-flex flex-row align-items-center">
                                                                <DatePicker
                                                                    className="form-control"
                                                                    wrapperClassName="datePicker"
                                                                    id="dtPagamento"
                                                                    type="date"
                                                                    locale="ptBR"
                                                                    dateFormat="dd/MM/yyyy"
                                                                    selected={venda.data_pagamento}
                                                                    onChange={(e) => onAtualizaDataPagamento(e)}
                                                                    filterDate={disableDays}
                                                                    value={venda.data_pagamento}
                                                                    minDate={new Date()}
                                                                    maxDate={new Date().setDate(new Date().getDate() + 30)}
                                                                />
                                                                <MdDateRange size="20" style={{cursor: "pointer"}} color="#759cc2" onClick={() => {
                                                                    document.getElementById("dtPagamento").focus();
                                                                }}/>
                                                            </div>
                                                            <div className="erros">
                                                                {validacao?.celularErro && <span>{validacao?.celularErro}</span>}
                                                            </div>                                                
                                                        </div>
                                                    }

                                                    <div className="d-flex flex-column w-100 colorTextoPadrao" style={{ marginTop: "20px" }}>
                                                        <div style={{ borderBottom: "1px dashed #759cc2" }}>
                                                            Descrição do produto (de acordo com a modalidade escolhida)
                                                        </div>

                                                        {venda && venda.produto &&
                                                            <div className="d-flex flex-column w-100" style={{ marginTop: "10px" }} id="descricao_produto" dangerouslySetInnerHTML={{ __html: venda.produto.descricao }}>
                                                            </div>
                                                        }
                                                    </div>

                                                    <div className="d-flex flex-row w-100 justify-content-end" style={{ marginTop: "100px", marginBottom: "100px" }}>
                                                        <button type="button" className="botaoPadrao" onClick={() => onContratar()}>Contratar</button>
                                                    </div>
                                                </>
                                            }
                                        </div>
                                    </TabPanel>

                                    <TabPanel style={{ padding: "0px 10px", border: "1px solid #aaa" }}>
                                        {loadingMask.upload && 
                                            <>
                                            <div className="d-flex flex-column w-100 align-items-center">
                                                <div className="d-flex flex-column bg-padrao align-items-center" style={{ width: "1150px" }}>
                                                    <div className="d-flex flex-column" style={{ width: "100%" }}>
                                                        <Skeleton count={30} height={"20px"} />
                                                    </div>
                                                </div>
                                            </div>
                                            </>
                                        }
                                        {!loadingMask.upload && 
                                        <div className="d-flex flex-column w-100">
                                                {propostaFinalizada &&
                                                    <div className="w-100" style={{ marginTop: "10px", padding: "10px 10px", textAlign: "center", backgroundColor: "#56b054", color: "white", fontSize: "20px" }}>
                                                        Proposta enviada com sucesso! Bem-vindo à Caixa Assistência.
                                                    </div>
                                                }

                                                {venda?.tipo_produto === "RAPIDEX_MOB" && 
                                                    <div style={{marginTop: 10}}>* A solicitação da tagCAIXA deve ser feita pelo cliente pela página www.rapidextagcaixa.caixaprepagos.com.br. Será enviado um whats app para o número de celular cadastrado do cliente com todas as orientações.</div>
                                                }

                                                {venda.pagamento === "BL" && venda.data_pagamento <= new Date() ?
                                                    <div className="d-flex flex-column w-100">
                                                        <div className="d-flex flex-row w-100">
                                                            <div className="d-flex flex-column align-items-center justify-content-center" style={{ width: "50%", height: "200px" }}>
                                                                {venda?.boleto?.url !== "" ?
                                                                    <input type="button" value="REEXIBIR BOLETO" style={{ marginBottom: "40px", backgroundColor: "#4c76c4", color: "white", border: "0px", borderRadius: "15px", padding: "7px 30px", width: "250px" }} onClick={() => reexibirBoleto()} />
                                                                    :
                                                                    <input type="button" value="REEXIBIR BOLETO" style={{ marginBottom: "40px", backgroundColor: "gray", color: "white", border: "0px", borderRadius: "15px", padding: "7px 30px", width: "250px" }} disabled={true} />
                                                                }

                                                                {!finalizando ?
                                                                    <input type="button" value="REEXIBIR PROPOSTA" style={{ backgroundColor: "#4c76c4", color: "white", border: "0px", borderRadius: "15px", padding: "7px 30px", width: "250px" }} onClick={() => imprimirProposta(false)} />
                                                                    :
                                                                    <input type="button" value="REEXIBIR PROPOSTA" style={{ backgroundColor: "gray", color: "white", border: "0px", borderRadius: "15px", padding: "7px 30px", width: "250px" }} disabled={true} />
                                                                }
                                                            </div>
                                                            <div className="d-flex flex-column align-items-center justify-content-center" style={{ width: "50%", height: "200px" }}>
                                                                <input type="button" value="CONDIÇÕES GERAIS" style={{ backgroundColor: "#4c76c4", color: "white", border: "0px", borderRadius: "15px", padding: "7px 30px", width: "250px" }} onClick={() => codicoesGerais()} />
                                                            </div>
                                                        </div>
                                                        {!venda?.venda_sms &&
                                                            <div className="d-flex flex-column align-items-center">
                                                                {acceptedFiles && acceptedFiles.length > 0 &&
                                                                    <div className="upload" style={{marginBottom: 20}}>
                                                                        {files}
                                                                    </div>
                                                                }

                                                                <div className="d-flex flex-row align-items-center justify-content-center">
                                                                    <div {...getRootProps()}>
                                                                        {!propostaFinalizada ?
                                                                            <>
                                                                                <input {...getInputProps()} />
                                                                                <button type="button" style={{ marginBottom: "40px", marginRight: "300px", backgroundColor: "#4c76c4", color: "white", border: "0px", borderRadius: "15px", padding: "7px 30px", width: "250px" }} onClick={open}>
                                                                                    <div className="d-flex align-items-center justify-content-center">
                                                                                        <FiPaperclip size={25} style={{marginRight: 10}}></FiPaperclip>
                                                                                        <div>ANEXAR ARQUIVO</div>
                                                                                    </div>
                                                                                </button>
                                                                            </>
                                                                            :
                                                                                <button type="button" style={{ marginBottom: "40px", marginRight: "300px", backgroundColor: "gray", color: "white", border: "0px", borderRadius: "15px", padding: "7px 30px", width: "250px" }} disabled={true}>
                                                                                    <div className="d-flex align-items-center justify-content-center">
                                                                                        <FiPaperclip size={25} style={{marginRight: 10}}></FiPaperclip>
                                                                                        <div>ANEXAR ARQUIVO</div>
                                                                                    </div>
                                                                                </button>
                                                                        }
                                                                    </div>

                                                                    {arquivoAnexado && !propostaFinalizada ?

                                                                        <button style={{ marginBottom: "40px", backgroundColor: "#e87d35", color: "white", border: "0px", borderRadius: "15px", padding: "7px 30px", width: "250px" }} onClick={() => finalizarProposta(venda.proposta, false)}>
                                                                            <div className="d-flex align-items-center justify-content-center">
                                                                                <div>FINALIZAR</div>
                                                                                <BiCheck size={25} style={{marginLeft: 10}}></BiCheck>
                                                                            </div>
                                                                        </button>
                                                                        :
                                                                        <button style={{ marginBottom: "40px", backgroundColor: "gray", color: "white", border: "0px", borderRadius: "15px", padding: "7px 30px", width: "250px" }} disabled={true}>
                                                                            <div className="d-flex align-items-center justify-content-center">
                                                                                <div>FINALIZAR</div>
                                                                                <BiCheck size={25} style={{marginLeft: 10}}></BiCheck>
                                                                            </div>
                                                                        </button>
                                                                    }
                                                                </div>
                                                            </div>
                                                        }
                                                    </div>
                                                    :
                                                    <>
                                                        <div style={{marginTop: 10}}>* condicionado a disponibilidade de saldo em conta no processamento noturno</div>
                                                        {!venda?.venda_sms &&
                                                            <div style={{marginTop: 10}}>* se não quiser anexar a proposta agora, você tem hoje até 23:59:59 horas para anexar pelo menu de pós-vendas</div>
                                                        }
                                                        {venda?.data_pagamento > new Date() &&
                                                            <div style={{marginTop: 10}}>* a emissão da proposta se dará após a cobrança da parcela na data escolhida</div>
                                                        }
                                                        <div className="d-flex flex-column w-100">
                                                            <div className="d-flex flex-row w-100">
                                                                {venda?.data_pagamento <= new Date() && venda?.url &&
                                                                    <div className="d-flex flex-column align-items-center justify-content-center" style={{ width: "50%", height: "300px" }}>
                                                                        <input type="button" value="PAGAMENTO" style={{ backgroundColor: "#4c76c4", color: "white", border: "0px", borderRadius: "15px", padding: "7px 30px", width: "250px" }} onClick={() => onAbrirPagamento()} />
                                                                    </div>
                                                                }
                                                                <div className="d-flex flex-column align-items-center justify-content-center" style={{ width: "50%", height: "300px" }}>
                                                                    <input type="button" value="CONDIÇÕES GERAIS" style={{ backgroundColor: "#4c76c4", color: "white", border: "0px", borderRadius: "15px", padding: "7px 30px", width: "250px" }} onClick={() => codicoesGerais()} />
                                                                </div>
                                                                <div className="d-flex flex-column align-items-center justify-content-center" style={{ width: "50%", height: "300px" }}>
                                                                    {!finalizando ?
                                                                        <input type="button" value="REEXIBIR PROPOSTA" style={{ backgroundColor: "#4c76c4", color: "white", border: "0px", borderRadius: "15px", padding: "7px 30px", width: "250px" }} onClick={() => imprimirProposta(false)} />
                                                                        :
                                                                        <input type="button" value="REEXIBIR PROPOSTA" style={{ backgroundColor: "gray", color: "white", border: "0px", borderRadius: "15px", padding: "7px 30px", width: "250px" }} disabled={true} />
                                                                    }
                                                                </div>
                                                            </div>
                                                            {!venda?.venda_sms &&
                                                                <div className="d-flex flex-column align-items-center">
                                                                    {acceptedFiles && acceptedFiles.length > 0 &&
                                                                        <div className="upload" style={{marginBottom: 20}}>
                                                                            {files}
                                                                        </div>
                                                                    }

                                                                    <div className="d-flex flex-row align-items-center justify-content-center">
                                                                        <div {...getRootProps()}>
                                                                            {!propostaFinalizada ?
                                                                                <>
                                                                                    <input {...getInputProps()} />
                                                                                    <button type="button" style={{ marginBottom: "40px", marginRight: "300px", backgroundColor: "#4c76c4", color: "white", border: "0px", borderRadius: "15px", padding: "7px 30px", width: "250px" }} onClick={open}>
                                                                                        <div className="d-flex align-items-center justify-content-center">
                                                                                            <FiPaperclip size={25} style={{marginRight: 10}}></FiPaperclip>
                                                                                            <div>ANEXAR ARQUIVO</div>
                                                                                        </div>
                                                                                    </button>
                                                                                </>
                                                                                :
                                                                                <button type="button" style={{ marginBottom: "40px", marginRight: "300px", backgroundColor: "gray", color: "white", border: "0px", borderRadius: "15px", padding: "7px 30px", width: "250px" }} disabled={true}>
                                                                                    <div className="d-flex align-items-center justify-content-center">
                                                                                        <FiPaperclip size={25} style={{marginRight: 10}}></FiPaperclip>
                                                                                        <div>ANEXAR ARQUIVO</div>
                                                                                    </div>
                                                                                </button>                                                                        
                                                                            }
                                                                        </div>

                                                                        {arquivoAnexado && !propostaFinalizada ?
                                                                            <button style={{ marginBottom: "40px", backgroundColor: "#e87d35", color: "white", border: "0px", borderRadius: "15px", padding: "7px 30px", width: "250px" }} onClick={() => finalizarProposta(venda.proposta, false)}>
                                                                                <div className="d-flex align-items-center justify-content-center">
                                                                                    <div>FINALIZAR</div>
                                                                                    <BiCheck size={25} style={{marginLeft: 10}}></BiCheck>
                                                                                </div>
                                                                            </button>
                                                                        :
                                                                            <button style={{ marginBottom: "40px", backgroundColor: "gray", color: "white", border: "0px", borderRadius: "15px", padding: "7px 30px", width: "250px" }} disabled={true}>
                                                                                <div className="d-flex align-items-center justify-content-center">
                                                                                    <div>FINALIZAR</div>
                                                                                    <BiCheck size={25} style={{marginLeft: 10}}></BiCheck>
                                                                                </div>
                                                                            </button>                                                                    
                                                                        }
                                                                    </div>
                                                                </div>
                                                            }
                                                        </div>
                                                    </>
                                                }
                                        </div>
                                        }
                                    </TabPanel>
                                </Tabs>
                            </div>
                        </div>
                        </LoadingMask>
                    </div>

                    <Modal show={contratar} centered={true} size="lg">
                        <LoadingMask loading={loadingMask.sms} text={"Aguarde..."}>
                            <Modal.Header className="cabecalho_modal">
                                Escolha a modalidade de assinatura do contrato
                            </Modal.Header>
                            <Modal.Body>
                                {retornaMensagemContratar()}
                            </Modal.Body>
                            <Modal.Footer>
                                <div className="d-flex flex-row">

                                    {!finalizando &&
                                        <>
                                            {venda.habilitaVendaSMS &&
                                                <>
                                                <button type="button" className="botaoAzul" onClick={() => onEnviarCodigoSMS()}>Enviar SMS</button>
                                                </>
                                            }
                                            <span style={{ marginRight: "10px" }}></span>
                                            <button type="button" className="botaoAzul" onClick={() => imprimirProposta(true)}>Imprimir Proposta</button>
                                        </>
                                    }
                                    <span style={{ marginRight: "10px" }}></span>
                                    <button type="button" className="botaoLaranja" onClick={() => onVoltarSMS()}>Voltar</button>

                                </div>
                            </Modal.Footer>
                        </LoadingMask>
                    </Modal>

                    <Modal show={erro} centered={true} style={{zIndex: "999999"}}>
                        <Modal.Header className="cabecalho_modal">
                            Atenção:
                        </Modal.Header>
                        <Modal.Body>
                            <b>{mensagemErro}</b>
                        </Modal.Body>
                        <Modal.Footer>
                            <div className="d-flex flex-row">
                                <button type="button" className="botaoLaranja" onClick={() => setErro(false)}>Fechar</button>
                            </div>
                        </Modal.Footer>
                    </Modal>

                    {/* Enviar SMS */}
                    <Modal show={sms} centered={true} dialogClassName="modalSMS" onShow={() => setShowCountSms(true)}>
                        <LoadingMask loading={loadingMask.newSms} text={"Aguarde..."}>
                            <Modal.Header className="cabecalho_modal">
                                Por gentileza, confirme as informações abaixo:
                            </Modal.Header>
                            <Modal.Body>
                                {venda && venda?.proposta &&
                                    <div className="d-flex flex-column w-100 align-items-center">
                                        <p>Informe o código recebido pelo cliente no campo abaixo para confirmar assinatura eletrônica.</p>
                                        <p>Celular que foi enviado o {originEnvioSMS === "S" ? "SMS" : "WHATSAPP"} {venda.celular}</p>
                                        {codigoSMS &&
                                            <IMaskInput id="num_sms" mask="000000" className="inputSMS" onChange={(e) => setValorSMS(e.target.value)}></IMaskInput>
                                        }
                                    </div>
                                }
                            </Modal.Body>
                            <Modal.Footer>
                                <div className="d-flex flex-row">
                                    {!reenviarSMS && venda && venda?.proposta ?
                                        <>
                                            {!finalizando &&
                                                <button type="button" className="botaoAzul" onClick={() => onConfirmar()}>
                                                    Confirmar
                                                        &nbsp;
                                                        <Countdown 
                                                            key={1}
                                                            date={Date.now() + 50000} 
                                                            ref={countdownRef} 
                                                            renderer={renderer_time} 
                                                        />
                                                </button>
                                            }
                                            <span style={{ marginRight: "10px" }}></span>
                                            {!proibidoReenviarSMS ?
                                                <>
                                                    <button type="button" className="botaoAzul" onClick={() => onReenviarSMS()}>Reenviar SMS</button>
                                                    <span style={{ marginRight: "10px" }}></span>
                                                    {!proibidoEnviarWhats ?
                                                        <>
                                                            <button type="button" className="botaoAzul" onClick={() => onReenviarWhats()}>Enviar Whatsapp</button>
                                                            <span style={{ marginRight: "10px" }}></span>
                                                        </>
                                                        :
                                                        <>
                                                            <button type="button" className="botaoCinza" readOnly>Enviar Whatsapp</button>
                                                            <span style={{ marginRight: "10px" }}></span>
                                                        </>
                                                    }
                                                </>
                                                :
                                                <>
                                                    <button type="button" className="botaoCinza" readOnly>Reenviar SMS</button>
                                                    <span style={{ marginRight: "10px" }}></span>
                                                    <button type="button" className="botaoCinza" readOnly>Enviar Whatsapp</button>
                                                    <span style={{ marginRight: "10px" }}></span>
                                                </>
                                            }
                                        </>
                                        :
                                        <>
                                            <button type="button" className="botaoCinza" readOnly>Confirmar</button>
                                            <span style={{ marginRight: "10px" }}></span>
                                            <button type="button" className="botaoCinza" readOnly>Reenviar SMS</button>
                                            <span style={{ marginRight: "10px" }}></span>
                                            <button type="button" className="botaoCinza" readOnly>Enviar Whatsapp</button>
                                            <span style={{ marginRight: "10px" }}></span>
                                        </>
                                    }
                                    <button type="button" className="botaoLaranja" onClick={() => onSairJanelaSMS()}>Cancelar</button>
                                </div>
                            </Modal.Footer>
                        </LoadingMask>
                    </Modal>

                    <Modal show={tutorial} centered={true} dialogClassName="modalTutorial" onHide={onFechaTutorial}>
                        <ModalHeader closeButton>

                        </ModalHeader>
                        <Modal.Body>
                            <div className="d-flex flex-column align-items-center w-100">
                                <Carousel showArrows={true} showThumbs={false} width={450} height={600} showIndicators={true} showStatus={false}>
                                    <div className="d-flex flex-column align-items-center justify-content-between" style={{ height: 500, marginLeft: "50px" }}>
                                        <div style={{ width: 350 }}>
                                            <img src={prancheta}/>
                                        </div>
                                        <div>
                                            <p className="passo">Passo 1</p>
                                            <p className="bold">Imprima a proposta e peça para o cliente assinar.</p>
                                            <p>&nbsp;</p>
                                        </div>
                                    </div>
                                    <div className="d-flex flex-column align-items-center justify-content-between" style={{ height: 500 }}>
                                        <div style={{ width: 350 }}>
                                            <img src={pasta} />
                                        </div>
                                        <div>
                                            <p className="passo">Passo 2</p>
                                            <p className="bold">Escaneie a proposta assinada e salve em sua máquina local.</p>
                                            <p>&nbsp;</p>
                                        </div>
                                    </div>
                                    <div className="d-flex flex-column align-items-center justify-content-between" style={{ height: 500 }}>
                                        <div style={{ width: 350 }}>
                                            <img src={personagem} />
                                        </div>
                                        <div>
                                            <p className="passo">Passo 3</p>
                                            <p className="bold">Busque o arquivo em sua máquina, faça o upload no sistema e clique em "Finalizar".</p>
                                            <input type="button" value="Entendi" style={{ marginBottom: "40px", marginRight: "30px", backgroundColor: "#93c467", color: "white", border: "0px", borderRadius: "15px", padding: "7px 30px", width: "150px" }} onClick={() => onFechaTutorial()} />
                                            <p>&nbsp;</p>
                                        </div>
                                    </div>
                                </Carousel>
                            </div>
                        </Modal.Body>
                    </Modal>

                    <Modal show={modalErro} centered={true} dialogClassName="modalTutorial">
                        <Modal.Body>
                            <div className="d-flex flex-column align-items-center w-100">
                                {mensagemErro &&
                                    <div style={{ fontSize: 20, fontWeight: "bold", textAlign: "center" }}>
                                        {mensagemErro}
                                    </div>
                                }

                                <input type="button" value="Fechar" style={{ marginBottom: "10px", marginTop: "20px", backgroundColor: "#93c467", color: "white", border: "0px", borderRadius: "15px", padding: "7px 30px", width: "150px" }} onClick={() => setModalErro(false)} />
                            </div>
                        </Modal.Body>
                    </Modal>

                    <Modal show={modalPagamentoCartao} centered={true} dialogClassName="modalTutorial" size="xl">
                        <div style={{width: "100%", height: "670px"}}>
                            <Modal.Body>
                                {loadingMask.pagamento &&
                                    <>
                                    <div className="d-flex flex-column w-100 align-items-center" style={{marginTop: "20px"}}>
                                        <div className="d-flex flex-column align-items-center" style={{ width: "86%"}}>
                                            <div className="d-flex flex-column" style={{ width: "100%" }}>
                                                <div className="d-flex flex-row justify-content-between" style={{ width: "100%", marginTop: "1px"}}>
                                                    <Skeleton count={1} height={"90px"} width={"230px"}/>
                                                    <div className="d-flex flex-column" style={{marginTop: "20px"}}>
                                                        <Skeleton count={3} height={"10px"} style={{width: "250px", marginRight: "160px"}}/>
                                                    </div>
                                                </div>
                                                <span style={{marginTop: "20px"}}></span>
                                                <div className="d-flex flex-row w-100 justify-content-between">
                                                    <Skeleton count={1} height={"250px"} width={"550px"}/>
                                                    <Skeleton count={1} height={"390px"} width={"380px"}/>
                                                </div>
                                                <span style={{marginTop: "50px"}}></span>
                                                <Skeleton count={1} height={"40px"} width={"150px"} style={{borderRadius: "15px 15px 15px 15px"}}/>
                                            </div>
                                        </div>
                                    </div>
                                    </>
                                }
                                {!loadingMask.pagamento &&
                                    <>
                                    {pagamentoEfetuado === 0 &&
                                    <div className="d-flex flex-column align-items-center w-100">
                                        <div className="container">
                                            <header className="">
                                                <a href="" className="logo">
                                                    <img src="assets/img/logo.png" alt="CAIXA" />
                                                </a>

                                                <div className="dados">
                                                    <span>Caixa Assistência </span>
                                                    <span>CNPJ 39.565.194/0001-08 </span>
                                                    <span className="email">
                                                        <FaEnvelope style={{marginRight: "5px"}}></FaEnvelope>
                                                        suporte.pos_vendas@caixaassistencia.com.br
                                                    </span>
                                                </div>
                                            </header>

                                            <main>
                                                <div className="fatura">
                                                    <h4>Proposta #{venda.proposta} - ({format(new Date(), 'dd/MM/yyyy')})</h4>
                                                    <table>
                                                        <thead>
                                                            <tr>
                                                                <th>DESCRIÇÃO</th>
                                                                <th className="tr">VALOR</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr>
                                                                <td colSpan="2">
                                                                    <div className="area">
                                                                        <button id="btnToggleDetails" className="toggle-details" onClick={() => toggleDetailsClick()}>+</button>
                                                                        <span>Canal Digital - {venda?.produto?.nome}
                                                                            {venda?.renovacaoAutomatica === "S" &&
                                                                                <span> com recorrência</span>
                                                                            }
                                                                        </span>
                                                                        <span className="preco"> R$ {venda?.produto?.valor}</span>
                                                                    </div>
                                                                    <div className="details" id="idDetails" style={{ display: "none"}}>
                                                                        <div className="details-content">
                                                                            <p>PREÇO</p>
                                                                            <p>R$ {venda?.produto?.valor}</p>
                                                                        </div>
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                    <div className="totals">
                                                        <p>Subtotal: <strong>R$ {venda?.produto?.valor}</strong></p>
                                                        <h3>TOTAL A PAGAR: <strong>R$ {venda?.produto?.valor}</strong></h3>
                                                    </div>
                                                </div>

                                                <div className="accordion">
                                                    <div className="item active">
                                                        <div className="header">
                                                            <p>Cartão de crédito</p>
                                                        </div>
                                                        <div className="body">
                                                            <div className="paymentForm">
                                                                <div className="d-flex flex-row">
                                                                    <select id="flag" className="input_cartao" onChange={(e) => atualizaInfoCartao(e)} style={{marginRight: "5px"}}>
                                                                        <option value=""></option>
                                                                        <option value="visa">Visa</option>
                                                                        <option value="mastercard">Mastercard</option>
                                                                        <option value="amex">Amex</option>
                                                                        <option value="elo">Elo</option>
                                                                        <option value="hipercard">Hipercard</option>
                                                                        <option value="diners">Diners</option>
                                                                    </select>

                                                                    {cartao &&
                                                                        <>
                                                                        {cartao.flag === "visa" &&
                                                                            <>
                                                                            <img src="assets/img/visa.png" alt="Visa" style={{marginRight: "5px"}} className="cartoes" />
                                                                            </>
                                                                        }
                                                                        {cartao.flag === "mastercard" &&
                                                                            <>
                                                                            <img src="assets/img/mastercard.png" alt="MasterCard" style={{marginRight: "5px"}} className="cartoes"/>
                                                                            </>
                                                                        }
                                                                        {cartao.flag === "amex" &&
                                                                            <>
                                                                            <img src="assets/img/amex.png" alt="American Express" style={{marginRight: "5px"}} className="cartoes"/>
                                                                            </>
                                                                        }
                                                                        {cartao.flag === "elo" &&
                                                                            <>
                                                                            <img src="assets/img/elo.png" alt="Elo" style={{marginRight: "5px"}} className="cartoes"/>
                                                                            </>
                                                                        }
                                                                        {cartao.flag === "hipercard" &&
                                                                            <>
                                                                            <img src="assets/img/hipercard.png" alt="hipercard" style={{marginRight: "5px"}} className="cartoes"/>
                                                                            </>
                                                                        }
                                                                        {cartao.flag === "diners" &&
                                                                            <>
                                                                            <img src="assets/img/diners.png" alt="Diners Club" style={{marginRight: "5px"}} className="cartoes"/>
                                                                            </>
                                                                        }
                                                                        </>
                                                                    }
                                                                </div>
                                                                
                                                                <div style={{ position: "relative"}}>
                                                                    <input type="password" id="cardNumber" placeholder="Número do cartão" maxLength="19" className="input_cartao" value={cartao.cardNumber} onChange={(e) => identificarBandeira(e.target.value)}/>

                                                                    {!showCardNumber ?
                                                                        <IoMdEye id="toggleCardNumber" style={{ position: "absolute", right: "15px", top: "50%", transform: "translateY(-50%)", cursor: "pointer"}} onClick={() => toggleCardNumberClick()}></IoMdEye>
                                                                    :
                                                                        <IoMdEyeOff id="toggleCardNumber" style={{ position: "absolute", right: "15px", top: "50%", transform: "translateY(-50%)", cursor: "pointer"}} onClick={() => toggleCardNumberClick()}></IoMdEyeOff>
                                                                    }
                                                                </div>

                                                                <input type="text" id="cardHolder" placeholder="Nome no cartão" className="input_cartao" value={cartao.cardHolder} onChange={(e) => atualizaInfoCartao(e)}/>

                                                                <div className="col" style={{ position: "relative"}}>
                                                                    <input type="text" id="cardExpiration" placeholder="MM/AA" className="input_cartao" maxLength="5" value={cartao.cardExpiration} onChange={(e) => atualizaInfoCartao(e)}/>
                                                                    <input type="password" id="cardCVV" placeholder="CVV" className="input_cartao" maxLength="4" value={cartao.cardCVV} onChange={(e) => atualizaInfoCartao(e)}/>
                                                                    {!showCVV ?
                                                                        <IoMdEye id="toggleCVV" style={{ position: "absolute", right: "15px", top: "50%", transform: "translateY(-50%)", cursor: "pointer"}} onClick={() => toggleCVVClick()}></IoMdEye>
                                                                    :
                                                                        <IoMdEyeOff id="toggleCVV" style={{ position: "absolute", right: "15px", top: "50%", transform: "translateY(-50%)", cursor: "pointer"}} onClick={() => toggleCVVClick()}></IoMdEyeOff>
                                                                    }
                                                                </div>

                                                                <button onClick={() => onPagamentoCartao()}>
                                                                    Efetuar pagamento
                                                                    <IoLockClosed style={{ marginLeft: "5px"}}></IoLockClosed>
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </main>
                                        </div>
                                    </div>
                                    }
                                    {pagamentoEfetuado === 2 &&
                                        <div className="d-flex flex-column align-items-center justify-content-center w-100" style={{height: "580px"}}>
                                            <BsStopwatch size={110} color="#3455eb"></BsStopwatch>
                                            <span className="mensagemPgtoEfetuado" style={{marginTop: "15px"}}>Aguardando confirmação do pagamento!</span>
                                        </div>
                                    }
                                    {pagamentoEfetuado === 1 &&
                                        <div className="d-flex flex-column align-items-center justify-content-center w-100" style={{height: "580px"}}>
                                            <BsCheckCircleFill size={110} color="#3A6332"></BsCheckCircleFill>
                                            <span className="mensagemPgtoEfetuado" style={{marginTop: "15px"}}>Pagamento efetuado com sucesso!</span>
                                        </div>
                                    }
                                    {pagamentoEfetuado === 7 &&
                                        <div className="d-flex flex-column align-items-center justify-content-center w-100" style={{height: "580px"}}>
                                            <BsXCircle size={110} color="#ff0000"></BsXCircle>
                                            <span className="mensagemPgtoEfetuado" style={{marginTop: "15px"}}>Não foi possível processar o pagamento. Consulte sua instituição financeira.</span>
                                        </div>
                                    }
                                    <input type="button" value="Fechar" style={{ marginTop: "20px", marginLeft: "69px", backgroundColor: "#93c467", color: "white", border: "0px", borderRadius: "15px", padding: "7px 30px", width: "150px" }} onClick={() => onHideConfirmarPagamento("CR")} />
                                    </>
                                }
                            </Modal.Body>
                            </div>
                    </Modal>

                    <Modal show={modalPagamentoCartaoNovo} centered={true} dialogClassName="modalTutorial" size="xl">
                        <div style={{width: "100%", height: "670px"}}>
                            <Modal.Body>
                                {loadingMask.pagamento &&
                                    <>
                                    <div className="d-flex flex-column w-100 align-items-center" style={{marginTop: "20px"}}>
                                        <div className="d-flex flex-column align-items-center" style={{ width: "86%"}}>
                                            <div className="d-flex flex-column" style={{ width: "100%" }}>
                                                <div className="d-flex flex-row justify-content-between" style={{ width: "100%", marginTop: "1px"}}>
                                                    <Skeleton count={1} height={"90px"} width={"230px"}/>
                                                    <div className="d-flex flex-column" style={{marginTop: "20px"}}>
                                                        <Skeleton count={3} height={"10px"} style={{width: "250px", marginRight: "160px"}}/>
                                                    </div>
                                                </div>
                                                <span style={{marginTop: "20px"}}></span>
                                                <div className="d-flex flex-row w-100 justify-content-between">
                                                    <Skeleton count={1} height={"250px"} width={"550px"}/>
                                                    <Skeleton count={1} height={"390px"} width={"380px"}/>
                                                </div>
                                                <span style={{marginTop: "50px"}}></span>
                                                <Skeleton count={1} height={"40px"} width={"150px"} style={{borderRadius: "15px 15px 15px 15px"}}/>
                                            </div>
                                        </div>
                                    </div>
                                    </>
                                }
                                {!loadingMask.pagamento &&
                                    <>
                                    {pagamentoEfetuado === 0 &&
                                    <div className="d-flex flex-column align-items-center w-100">
                                        <div className="container">
                                            <header className="">
                                                <a href="" className="logo">
                                                    <img src="assets/img/logo.png" alt="CAIXA" />
                                                </a>

                                                <div className="dados">
                                                    <span>Caixa Assistência </span>
                                                    <span>CNPJ 39.565.194/0001-08 </span>
                                                    <span className="email">
                                                        <FaEnvelope style={{marginRight: "5px"}}></FaEnvelope>
                                                        suporte.pos_vendas@caixaassistencia.com.br
                                                    </span>
                                                </div>
                                            </header>

                                            <main>
                                                <div className="fatura">
                                                    <h4>Proposta #{venda.proposta} - ({format(new Date(), 'dd/MM/yyyy')})</h4>
                                                    <table>
                                                        <thead>
                                                            <tr>
                                                                <th>DESCRIÇÃO</th>
                                                                <th className="tr">VALOR</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr>
                                                                <td colSpan="2">
                                                                    <div className="area">
                                                                        <button id="btnToggleDetails" className="toggle-details" onClick={() => toggleDetailsClick()}>+</button>
                                                                        <span>Canal Digital - {venda?.produto?.nome}
                                                                            {venda?.renovacaoAutomatica === "S" &&
                                                                                <span> com recorrência</span>
                                                                            }
                                                                        </span>
                                                                        <span className="preco"> R$ {venda?.produto?.valor}</span>
                                                                    </div>
                                                                    <div className="details" id="idDetails" style={{ display: "none"}}>
                                                                        <div className="details-content">
                                                                            <p>PREÇO</p>
                                                                            <p>R$ {venda?.produto?.valor}</p>
                                                                        </div>
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                    <div className="totals">
                                                        <p>Subtotal: <strong>R$ {venda?.produto?.valor}</strong></p>
                                                        <h3>TOTAL A PAGAR: <strong>R$ {venda?.produto?.valor}</strong></h3>
                                                    </div>
                                                </div>

                                                <div className="accordion">
                                                    <div className="item active">
                                                        <div className="header">
                                                            <p>Cartão de crédito</p>
                                                        </div>
                                                        <div className="body">
                                                            <div className="paymentForm">
                                                                <div className="d-flex flex-row">
                                                                    <select id="flag" className="input_cartao" onChange={(e) => atualizaInfoCartao(e)} style={{marginRight: "5px"}} value={cartao.flag}>
                                                                        <option value=""></option>
                                                                        <option value="1">Visa</option>
                                                                        <option value="2">Mastercard</option>
                                                                        <option value="3">Amex</option>
                                                                        <option value="41">Elo</option>
                                                                        <option value="5">Hipercard</option>
                                                                        <option value="33">Diners</option>
                                                                    </select>

                                                                    {cartao &&
                                                                        <>
                                                                        {cartao.flag === "1" &&
                                                                            <>
                                                                            <img src="assets/img/visa.png" alt="Visa" style={{marginRight: "5px"}} className="cartoes" />
                                                                            </>
                                                                        }
                                                                        {cartao.flag === "2" &&
                                                                            <>
                                                                            <img src="assets/img/mastercard.png" alt="MasterCard" style={{marginRight: "5px"}} className="cartoes"/>
                                                                            </>
                                                                        }
                                                                        {cartao.flag === "3" &&
                                                                            <>
                                                                            <img src="assets/img/amex.png" alt="American Express" style={{marginRight: "5px"}} className="cartoes"/>
                                                                            </>
                                                                        }
                                                                        {cartao.flag === "41" &&
                                                                            <>
                                                                            <img src="assets/img/elo.png" alt="Elo" style={{marginRight: "5px"}} className="cartoes"/>
                                                                            </>
                                                                        }
                                                                        {cartao.flag === "5" &&
                                                                            <>
                                                                            <img src="assets/img/hipercard.png" alt="hipercard" style={{marginRight: "5px"}} className="cartoes"/>
                                                                            </>
                                                                        }
                                                                        {cartao.flag === "33" &&
                                                                            <>
                                                                            <img src="assets/img/diners.png" alt="Diners Club" style={{marginRight: "5px"}} className="cartoes"/>
                                                                            </>
                                                                        }
                                                                        </>
                                                                    }
                                                                </div>
                                                                
                                                                <div style={{ position: "relative"}}>
                                                                    <input type="password" id="cardNumber" placeholder="Número do cartão" maxLength="19" className="input_cartao" value={cartao.cardNumber} onChange={(e) => identificarBandeira(e.target.value)}/>

                                                                    {!showCardNumber ?
                                                                        <IoMdEye id="toggleCardNumber" style={{ position: "absolute", right: "15px", top: "50%", transform: "translateY(-50%)", cursor: "pointer"}} onClick={() => toggleCardNumberClick()}></IoMdEye>
                                                                    :
                                                                        <IoMdEyeOff id="toggleCardNumber" style={{ position: "absolute", right: "15px", top: "50%", transform: "translateY(-50%)", cursor: "pointer"}} onClick={() => toggleCardNumberClick()}></IoMdEyeOff>
                                                                    }
                                                                </div>

                                                                <input type="text" id="cardHolder" placeholder="Nome no cartão" className="input_cartao" value={cartao.cardHolder} onChange={(e) => atualizaInfoCartao(e)}/>

                                                                <div className="col" style={{ position: "relative"}}>
                                                                    <input type="text" id="cardExpiration" placeholder="MM/AA" className="input_cartao" maxLength="5" value={cartao.cardExpiration} onChange={(e) => atualizaInfoCartao(e)}/>
                                                                    <input type="password" id="cardCVV" placeholder="CVV" className="input_cartao" maxLength="4" value={cartao.cardCVV} onChange={(e) => atualizaInfoCartao(e)}/>
                                                                    {!showCVV ?
                                                                        <IoMdEye id="toggleCVV" style={{ position: "absolute", right: "15px", top: "50%", transform: "translateY(-50%)", cursor: "pointer"}} onClick={() => toggleCVVClick()}></IoMdEye>
                                                                    :
                                                                        <IoMdEyeOff id="toggleCVV" style={{ position: "absolute", right: "15px", top: "50%", transform: "translateY(-50%)", cursor: "pointer"}} onClick={() => toggleCVVClick()}></IoMdEyeOff>
                                                                    }
                                                                </div>

                                                                <button onClick={() => onPagamentoCartaoNovo()}>
                                                                    Efetuar pagamento
                                                                    <IoLockClosed style={{ marginLeft: "5px"}}></IoLockClosed>
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </main>
                                        </div>
                                    </div>
                                    }
                                    {pagamentoEfetuado === 2 &&
                                        <div className="d-flex flex-column align-items-center justify-content-center w-100" style={{height: "580px"}}>
                                            <BsStopwatch size={110} color="#3455eb"></BsStopwatch>
                                            <span className="mensagemPgtoEfetuado" style={{marginTop: "15px"}}>Aguardando confirmação do pagamento!</span>
                                        </div>
                                    }
                                    {pagamentoEfetuado === 1 &&
                                        <div className="d-flex flex-column align-items-center justify-content-center w-100" style={{height: "580px"}}>
                                            <BsCheckCircleFill size={110} color="#3A6332"></BsCheckCircleFill>
                                            <span className="mensagemPgtoEfetuado" style={{marginTop: "15px"}}>Pagamento efetuado com sucesso!</span>
                                        </div>
                                    }
                                    {pagamentoEfetuado === 7 &&
                                        <div className="d-flex flex-column align-items-center justify-content-center w-100" style={{height: "580px"}}>
                                            <BsXCircle size={110} color="#ff0000"></BsXCircle>
                                            <span className="mensagemPgtoEfetuado" style={{marginTop: "15px"}}>Não foi possível processar o pagamento. Consulte sua instituição financeira.</span>
                                        </div>
                                    }
                                    <input type="button" value="Fechar" style={{ marginTop: "20px", marginLeft: "69px", backgroundColor: "#93c467", color: "white", border: "0px", borderRadius: "15px", padding: "7px 30px", width: "150px" }} onClick={() => onHideConfirmarPagamento("CR")} />
                                    </>
                                }
                            </Modal.Body>
                            </div>
                    </Modal>

                    <Modal show={modalPagamentoPix} centered={true} dialogClassName="modalTutorial" size="xl" onShow={() => onShowConfirmarPagamento("PX")}>
                        <div style={{width: "100%", height: "670px"}}>
                            <Modal.Body>
                                {loadingMask.pagamentoPix &&
                                    <>
                                        <div className="d-flex flex-column w-100 align-items-center" style={{marginTop: "20px"}}>
                                            <div className="d-flex flex-column align-items-center" style={{ width: "86%"}}>
                                                <div className="d-flex flex-column" style={{ width: "100%" }}>
                                                    <div className="d-flex flex-row justify-content-between" style={{ width: "100%", marginTop: "1px"}}>
                                                        <Skeleton count={1} height={"90px"} width={"230px"}/>
                                                        <div className="d-flex flex-column" style={{marginTop: "20px"}}>
                                                            <Skeleton count={3} height={"10px"} style={{width: "250px", marginRight: "160px"}}/>
                                                        </div>
                                                    </div>
                                                    <span style={{marginTop: "20px"}}></span>
                                                    <div className="d-flex flex-row w-100 justify-content-between">
                                                        <Skeleton count={1} height={"250px"} width={"550px"}/>
                                                        <Skeleton count={1} height={"390px"} width={"380px"}/>
                                                    </div>
                                                    <span style={{marginTop: "50px"}}></span>
                                                    <Skeleton count={1} height={"40px"} width={"150px"} style={{borderRadius: "15px 15px 15px 15px"}}/>
                                                </div>
                                            </div>
                                        </div>
                                    </>
                                }
                                {!loadingMask.pagamentoPix &&
                                    <>
                                        {pagamentoEfetuado === 0 &&
                                            <div className="d-flex flex-column align-items-center w-100">
                                                <div className="container">
                                                    <header className="">
                                                        <a href="" className="logo">
                                                            <img src="assets/img/logo.png" alt="CAIXA" />
                                                        </a>

                                                        <div className="dados">
                                                            <span>Caixa Assistência </span>
                                                            <span>CNPJ 39.565.194/0001-08 </span>
                                                            <span className="email">
                                                        <FaEnvelope style={{marginRight: "5px"}}></FaEnvelope>
                                                        suporte.pos_vendas@caixaassistencia.com.br
                                                    </span>
                                                        </div>
                                                    </header>

                                                    <main>
                                                        <div className="fatura">
                                                            <h4>Proposta #{venda.proposta} - ({format(new Date(), 'dd/MM/yyyy')})</h4>
                                                            <table>
                                                                <thead>
                                                                <tr>
                                                                    <th>DESCRIÇÃO</th>
                                                                    <th className="tr">VALOR</th>
                                                                </tr>
                                                                </thead>
                                                                <tbody>
                                                                <tr>
                                                                    <td colSpan="2">
                                                                        <div className="area">
                                                                            <button id="btnToggleDetails" className="toggle-details" onClick={() => toggleDetailsClick()}>+</button>
                                                                            <span>Canal Digital - {venda?.produto?.nome}
                                                                                {venda?.renovacaoAutomatica === "S" &&
                                                                                    <span> com recorrência</span>
                                                                                }
                                                                        </span>
                                                                            <span className="preco"> R$ {venda?.produto?.valor}</span>
                                                                        </div>
                                                                        <div className="details" id="idDetails" style={{ display: "none"}}>
                                                                            <div className="details-content">
                                                                                <p>PREÇO</p>
                                                                                <p>R$ {venda?.produto?.valor}</p>
                                                                            </div>
                                                                        </div>
                                                                    </td>
                                                                </tr>
                                                                </tbody>
                                                            </table>
                                                            <div className="totals">
                                                                <p>Subtotal: <strong>R$ {venda?.produto?.valor}</strong></p>
                                                                <h3>TOTAL A PAGAR: <strong>R$ {venda?.produto?.valor}</strong></h3>
                                                            </div>
                                                        </div>

                                                        <div className="accordion">
                                                            <div className="item active">
                                                                <div className="header">
                                                                    <p>Pix</p>
                                                                </div>
                                                                <div className="body">
                                                                    <div className="paymentForm">
                                                                        <div className="d-flex flex-row">
                                                                        </div>

                                                                        <div
                                                                            style={{
                                                                                position: "relative",
                                                                                display: "flex",
                                                                                justifyContent: "center",
                                                                                alignItems: "center",
                                                                                width: "100%",
                                                                            }}
                                                                        >
                                                                            <QRCode value={venda.pix} size={216} />
                                                                        </div>

                                                                        <div
                                                                            style={{
                                                                                position: "relative",
                                                                                display: "flex",
                                                                                justifyContent: "center",
                                                                                alignItems: "center",
                                                                                width: "100%",
                                                                            }}
                                                                        >
                                                                            <button onClick={() => onCopiarPix()} style={{ width: "216px" }}>
                                                                                Copiar Pix
                                                                            </button>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </main>
                                                </div>
                                            </div>
                                        }
                                        {pagamentoEfetuado === 1 &&
                                            <div className="d-flex flex-column align-items-center justify-content-center w-100" style={{height: "580px"}}>
                                                <BsCheckCircleFill size={110} color="#3A6332"></BsCheckCircleFill>
                                                <span className="mensagemPgtoEfetuado" style={{marginTop: "15px"}}>Pagamento efetuado com sucesso!</span>
                                            </div>
                                        }
                                        {pagamentoEfetuado === 7 &&
                                            <div className="d-flex flex-column align-items-center justify-content-center w-100" style={{height: "580px"}}>
                                                <BsXCircle size={110} color="#ff0000"></BsXCircle>
                                                <span className="mensagemPgtoEfetuado" style={{marginTop: "15px"}}>Não foi possível processar o pagamento. Consulte sua instituição financeira.</span>
                                            </div>
                                        }
                                        <input type="button" value="Fechar" style={{ marginTop: "20px", marginLeft: "69px", backgroundColor: "#93c467", color: "white", border: "0px", borderRadius: "15px", padding: "7px 30px", width: "150px" }} onClick={() => onHideConfirmarPagamento("PX")} />
                                    </>
                                }
                            </Modal.Body>
                        </div>
                    </Modal>

                    <Modal show={modalPagamentoPixNovo} centered={true} dialogClassName="modalTutorial" size="xl" onShow={() => onShowConfirmarPagamentoNovo("PX")}>
                        <div style={{width: "100%", height: "670px"}}>
                            <Modal.Body>
                                {loadingMask.pagamentoPix &&
                                    <>
                                        <div className="d-flex flex-column w-100 align-items-center" style={{marginTop: "20px"}}>
                                            <div className="d-flex flex-column align-items-center" style={{ width: "86%"}}>
                                                <div className="d-flex flex-column" style={{ width: "100%" }}>
                                                    <div className="d-flex flex-row justify-content-between" style={{ width: "100%", marginTop: "1px"}}>
                                                        <Skeleton count={1} height={"90px"} width={"230px"}/>
                                                        <div className="d-flex flex-column" style={{marginTop: "20px"}}>
                                                            <Skeleton count={3} height={"10px"} style={{width: "250px", marginRight: "160px"}}/>
                                                        </div>
                                                    </div>
                                                    <span style={{marginTop: "20px"}}></span>
                                                    <div className="d-flex flex-row w-100 justify-content-between">
                                                        <Skeleton count={1} height={"250px"} width={"550px"}/>
                                                        <Skeleton count={1} height={"390px"} width={"380px"}/>
                                                    </div>
                                                    <span style={{marginTop: "50px"}}></span>
                                                    <Skeleton count={1} height={"40px"} width={"150px"} style={{borderRadius: "15px 15px 15px 15px"}}/>
                                                </div>
                                            </div>
                                        </div>
                                    </>
                                }
                                {!loadingMask.pagamentoPix &&
                                    <>
                                        {pagamentoEfetuado === 0 &&
                                            <div className="d-flex flex-column align-items-center w-100">
                                                <div className="container">
                                                    <header className="">
                                                        <a href="" className="logo">
                                                            <img src="assets/img/logo.png" alt="CAIXA" />
                                                        </a>

                                                        <div className="dados">
                                                            <span>Caixa Assistência </span>
                                                            <span>CNPJ 39.565.194/0001-08 </span>
                                                            <span className="email">
                                                        <FaEnvelope style={{marginRight: "5px"}}></FaEnvelope>
                                                        suporte.pos_vendas@caixaassistencia.com.br
                                                    </span>
                                                        </div>
                                                    </header>

                                                    <main>
                                                        <div className="fatura">
                                                            <h4>Proposta #{venda.proposta} - ({format(new Date(), 'dd/MM/yyyy')})</h4>
                                                            <table>
                                                                <thead>
                                                                <tr>
                                                                    <th>DESCRIÇÃO</th>
                                                                    <th className="tr">VALOR</th>
                                                                </tr>
                                                                </thead>
                                                                <tbody>
                                                                <tr>
                                                                    <td colSpan="2">
                                                                        <div className="area">
                                                                            <button id="btnToggleDetails" className="toggle-details" onClick={() => toggleDetailsClick()}>+</button>
                                                                            <span>Canal Digital - {venda?.produto?.nome}
                                                                                {venda?.renovacaoAutomatica === "S" &&
                                                                                    <span> com recorrência</span>
                                                                                }
                                                                        </span>
                                                                            <span className="preco"> R$ {venda?.produto?.valor}</span>
                                                                        </div>
                                                                        <div className="details" id="idDetails" style={{ display: "none"}}>
                                                                            <div className="details-content">
                                                                                <p>PREÇO</p>
                                                                                <p>R$ {venda?.produto?.valor}</p>
                                                                            </div>
                                                                        </div>
                                                                    </td>
                                                                </tr>
                                                                </tbody>
                                                            </table>
                                                            <div className="totals">
                                                                <p>Subtotal: <strong>R$ {venda?.produto?.valor}</strong></p>
                                                                <h3>TOTAL A PAGAR: <strong>R$ {venda?.produto?.valor}</strong></h3>
                                                            </div>
                                                        </div>

                                                        <div className="accordion">
                                                            <div className="item active">
                                                                <div className="header">
                                                                    <p>Pix</p>
                                                                </div>
                                                                <div className="body">
                                                                    <div className="paymentForm">
                                                                        <div className="d-flex flex-row">
                                                                        </div>

                                                                        <div
                                                                            style={{
                                                                                position: "relative",
                                                                                display: "flex",
                                                                                justifyContent: "center",
                                                                                alignItems: "center",
                                                                                width: "100%",
                                                                            }}
                                                                        >
                                                                            <QRCode value={venda.pix} size={216} />
                                                                        </div>

                                                                        <div
                                                                            style={{
                                                                                position: "relative",
                                                                                display: "flex",
                                                                                justifyContent: "center",
                                                                                alignItems: "center",
                                                                                width: "100%",
                                                                            }}
                                                                        >
                                                                            <button onClick={() => onCopiarPix()} style={{ width: "216px" }}>
                                                                                Copiar Pix
                                                                            </button>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </main>
                                                </div>
                                            </div>
                                        }
                                        {pagamentoEfetuado === 1 &&
                                            <div className="d-flex flex-column align-items-center justify-content-center w-100" style={{height: "580px"}}>
                                                <BsCheckCircleFill size={110} color="#3A6332"></BsCheckCircleFill>
                                                <span className="mensagemPgtoEfetuado" style={{marginTop: "15px"}}>Pagamento efetuado com sucesso!</span>
                                            </div>
                                        }
                                        {pagamentoEfetuado === 7 &&
                                            <div className="d-flex flex-column align-items-center justify-content-center w-100" style={{height: "580px"}}>
                                                <BsXCircle size={110} color="#ff0000"></BsXCircle>
                                                <span className="mensagemPgtoEfetuado" style={{marginTop: "15px"}}>Não foi possível processar o pagamento. Consulte sua instituição financeira.</span>
                                            </div>
                                        }
                                        <input type="button" value="Fechar" style={{ marginTop: "20px", marginLeft: "69px", backgroundColor: "#93c467", color: "white", border: "0px", borderRadius: "15px", padding: "7px 30px", width: "150px" }} onClick={() => onHideConfirmarPagamento("PX")} />
                                    </>
                                }
                            </Modal.Body>
                        </div>
                    </Modal>
                </>
            }
        </>
    )
}
